const WIZARD_STEPS = [
  { id: 1, label: 'Registro', key: 'enroll' },
  { id: 2, label: 'Pago', key: 'pay' },
  { id: 3, label: 'Brief', key: 'brief' },
  { id: 4, label: 'Sube tu caso', key: 'case' },
];

const STEP_INTROS = {
  enroll: {
    title: 'Registro del equipo',
    lead: 'Registra seudónimo, integrantes (2 a 4) con su DNI, y confirma si tu agencia es socia APAP.',
  },
  pay: {
    title: 'Pago de inscripción',
    lead: 'Revisa tu equipo y completa el pago de la inscripción en Shopify.',
  },
  brief: {
    title: 'Brief oficial',
    lead: 'Tu inscripción y pago a Jóvenes Talento están confirmados.',
  },
  case: {
    title: 'Sube tu caso',
    lead: 'Completa la ficha de registro del caso y adjunta el material creativo.',
  },
};

const BRIEF_DOWNLOAD_URL = 'https://apap.org.pe/brief-jovenes-talentos-2026';
const BASES_DOWNLOAD_URL = 'https://apap.org.pe/bases-jovenes-talento-2026';

/** Solo para QA visual de fases de interfaz. */
const JT_PHASE_PREVIEW_EMAILS = ['nicolas@cluster.pe'];

const JT_PHASE_PREVIEW_OPTIONS = [
  { key: 'login', label: 'Login' },
  { key: 'profile', label: 'Perfil' },
  { key: 'enroll', label: 'Registro' },
  { key: 'pay', label: 'Pago' },
  { key: 'brief-pending', label: 'Brief pendiente' },
  { key: 'brief-open', label: 'Brief disponible' },
  { key: 'case', label: 'Subir caso' },
  { key: 'observed', label: 'Observado' },
  { key: 'done', label: 'Enviado' },
  { key: 'registration', label: 'Resumen registro' },
  { key: 'real', label: 'Estado real' },
];

const ENABLE_VIDEO_FILE_UPLOAD = true;
const MAX_CREATIVE_PIECES = 3;
const MAX_IMAGE_PIXELS = 5000;

const MEDIA_UPLOAD_LIMITS = {
  IMAGE: {
    maxBytes: 20 * 1024 * 1024,
    maxPixels: MAX_IMAGE_PIXELS,
    accept: ['image/jpeg', 'image/png', 'image/webp', 'image/gif'],
    label: '20 MB',
  },
  AUDIO: {
    maxBytes: 50 * 1024 * 1024,
    accept: ['audio/mpeg', 'audio/wav', 'audio/mp3', 'audio/x-wav'],
    label: '50 MB',
  },
  PDF: {
    maxBytes: 20 * 1024 * 1024,
    accept: ['application/pdf'],
    label: '20 MB',
  },
  VIDEO: {
    maxBytes: 400 * 1024 * 1024,
    accept: ['video/mp4', 'video/quicktime'],
    label: '400 MB',
  },
};

/** Detección de códec MP4/MOV (fourcc). Solo se permiten videos H.264. */
const VIDEO_FOURCC = {
  avc1: [0x61, 0x76, 0x63, 0x31],
  avc3: [0x61, 0x76, 0x63, 0x33],
  av01: [0x61, 0x76, 0x30, 0x31],
  hev1: [0x68, 0x65, 0x76, 0x31],
  hvc1: [0x68, 0x76, 0x63, 0x31],
};

function includesFourcc(haystack, needle) {
  outer: for (let i = 0; i <= haystack.length - needle.length; i += 1) {
    for (let j = 0; j < needle.length; j += 1) {
      if (haystack[i + j] !== needle[j]) continue outer;
    }
    return true;
  }
  return false;
}

function detectMp4VideoCodec(data) {
  if (includesFourcc(data, VIDEO_FOURCC.av01)) return 'av1';
  if (includesFourcc(data, VIDEO_FOURCC.hev1) || includesFourcc(data, VIDEO_FOURCC.hvc1)) {
    return 'hevc';
  }
  if (includesFourcc(data, VIDEO_FOURCC.avc1) || includesFourcc(data, VIDEO_FOURCC.avc3)) {
    return 'h264';
  }
  return 'unknown';
}

function shopifyVideoUploadErrorMessage(codec, fileName) {
  const name = fileName ? ` "${fileName}"` : '';
  return (
    `El formato del video${name} no está permitido. ` +
    'Solo se permiten MP4 o MOV en H.264 (AVC) con audio AAC.'
  );
}

async function assertShopifyCompatibleVideoFile(file) {
  const PROBE = 8 * 1024 * 1024;
  let bytes;
  if (file.size <= PROBE * 2) {
    bytes = new Uint8Array(await file.arrayBuffer());
  } else {
    const head = new Uint8Array(await file.slice(0, PROBE).arrayBuffer());
    const tail = new Uint8Array(await file.slice(file.size - PROBE).arrayBuffer());
    bytes = new Uint8Array(head.length + tail.length);
    bytes.set(head, 0);
    bytes.set(tail, head.length);
  }
  const codec = detectMp4VideoCodec(bytes);
  if (codec !== 'h264') {
    throw new Error(shopifyVideoUploadErrorMessage(codec, file.name));
  }
  return codec;
}

const FORMATS = [
  { value: 'GRAFICA', label: 'Pieza gráfica (print o key visual)' },
  { value: 'DIGITAL', label: 'Idea digital' },
  { value: 'ACTIVACION', label: 'Activación' },
  { value: 'AUDIO', label: 'Audio (spot radial o jingle)' },
  { value: 'VIDEOCASO', label: 'Videocaso (máx. 2 min)' },
];

const MEMBER_TYPES = [
  { value: 'AGENCY_PRO', label: 'Profesional de agencia' },
  { value: 'FREELANCER', label: 'Freelancer / independiente' },
  { value: 'STUDENT', label: 'Estudiante' },
];

const MIN_MEMBERS = 2;
const MAX_MEMBERS = 4;

const ACCEPT_TERMS_FIELD = 'acceptTerms';
const ACCEPT_PRIVACY_FIELD = 'acceptPrivacy';
const LEGAL_ACCEPTANCE_ERROR_MESSAGE =
  'Debes aceptar los términos, las bases del premio y las políticas de privacidad para enviar.';

function hasCaseProgress(team) {
  const proposal = team?.proposal;
  if (!proposal) return false;
  if (proposal.status === 'OBSERVED') return true;
  if (proposal.mediaAssets?.length) return true;
  return Boolean(
    proposal.format ||
      proposal.strategyContext?.trim() ||
      proposal.strategyInsight?.trim() ||
      proposal.strategyVision?.trim(),
  );
}

function resolveWizardStep(team, brief) {
  if (!team) return 'enroll';
  if (team.paymentStatus !== 'PAID') return 'pay';

  const proposal = team.proposal;
  const submittedStatuses = ['SUBMITTED', 'UNDER_REVIEW', 'VERIFIED', 'SHORTLIST', 'WINNER'];
  if (submittedStatuses.includes(proposal?.status)) return 'done';
  if (hasCaseProgress(team)) return 'case';
  if (!brief) return 'brief';
  if (sessionStorage.getItem(`apap-jt-brief-${team.id}`) === '1') return 'case';
  return 'brief';
}

function stepKeyToIndex(stepKey) {
  const index = WIZARD_STEPS.findIndex((step) => step.key === stepKey);
  return index >= 0 ? index + 1 : 1;
}

function emptyMember() {
  return {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    birthDate: '',
    memberType: 'AGENCY_PRO',
    agencyName: '',
    identityFile: null,
    identityFileName: '',
    identityUploaded: false,
  };
}

function emptyProfileForm() {
  return {
    firstName: '',
    lastName: '',
    organization: '',
    phone: '',
    ruc: '',
    razonSocial: '',
    isApapPartner: false,
    partnerAgencyId: '',
    invoiceEmail: '',
    invoiceContactName: '',
  };
}

function readHostConfig(host) {
  let loginUrl = host.dataset.loginUrl || '/account/login';
  let loginRedirect = host.dataset.loginRedirect || window.location.pathname;

  // Liquid legacy: return_url pegado con ? aunque la URL ya tuviera query string.
  const legacyReturn = loginUrl.match(/[?&]return_url=([^&]+)/);
  if (legacyReturn && !host.dataset.loginRedirect) {
    loginRedirect = decodeURIComponent(legacyReturn[1]);
    loginUrl = loginUrl.replace(/([?&])return_url=[^&]+/, (_, separator) =>
      separator === '?' && !loginUrl.includes('&') ? '?' : '',
    );
    loginUrl = loginUrl.replace(/\?$/, '');
  }

  return {
    apiBase: host.dataset.apiBase || '/apps/apap/api/theme',
    uploadBase: host.dataset.uploadBase || '/apps/apap/api',
    basesUrl: host.dataset.basesUrl || '#',
    termsUrl: host.dataset.termsUrl || '#',
    privacyUrl: host.dataset.privacyUrl || '#',
    loginUrl,
    loginRedirect,
  };
}

class ApapJtApp {
  constructor(host) {
    this.host = host;
    const config = readHostConfig(host);
    this.apiBase = config.apiBase;
    this.uploadBase = config.uploadBase;
    this.basesUrl = config.basesUrl;
    this.termsUrl = config.termsUrl;
    this.privacyUrl = config.privacyUrl;
    this.loginUrl = config.loginUrl;
    this.loginRedirect = config.loginRedirect;
    this.state = {
      loading: true,
      authenticated: false,
      step: 'enroll',
      team: null,
      brief: null,
      members: [emptyMember(), emptyMember()],
      phase: null,
      partnerAgencies: [],
      isApapPartner: false,
      enrollPseudonym: '',
      enrollAgencyName: '',
      enrollPartnerAgencyId: '',
      participant: null,
      profileForm: emptyProfileForm(),
      previewPhase: null,
      registrationReturnStep: null,
    };
  }

  isTeamPaid(team = this.state.team) {
    return team?.paymentStatus === 'PAID';
  }

  formatMemberTypeLabel(member) {
    return (
      member?.memberTypeLabel ||
      MEMBER_TYPES.find((item) => item.value === member?.memberType)?.label ||
      member?.memberType ||
      '—'
    );
  }

  formatBirthDateLabel(value) {
    if (!value) return '—';
    const date = new Date(`${String(value).slice(0, 10)}T12:00:00`);
    if (Number.isNaN(date.getTime())) return String(value);
    return date.toLocaleDateString('es-PE', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
  }

  renderRegistrationSummaryButton({ ghost = true } = {}) {
    if (!this.isTeamPaid()) return '';
    const className = ghost
      ? 'apap-postulacion__btn apap-postulacion__btn--ghost'
      : 'apap-postulacion__btn apap-postulacion__btn--ghost apap-postulacion__btn--sm';
    return `<button type="button" class="${className}" data-action="view-registration">Ver resumen del registro</button>`;
  }

  openRegistrationSummary() {
    if (!this.isTeamPaid()) return;
    const returnStep =
      this.state.view === 'registration-summary'
        ? this.state.registrationReturnStep
        : this.state.step === 'done'
          ? 'done'
          : this.state.step;
    this.setState({
      view: 'registration-summary',
      registrationReturnStep: returnStep || 'brief',
      authenticated: true,
      loading: false,
    });
  }

  closeRegistrationSummary() {
    const returnStep = this.state.registrationReturnStep || 'brief';
    this.setState({
      view: 'app',
      step: returnStep,
      registrationReturnStep: null,
    });
  }

  renderRegistrationSummary() {
    const team = this.state.team;
    if (!team) {
      return `
        <div class="apap-postulacion__panel">
          ${this.renderCard(
            'Resumen del registro',
            '<p class="apap-postulacion__section-lead">Aún no hay un equipo registrado para mostrar.</p>',
          )}
          <div class="apap-postulacion__wizard-footer">
            <div class="apap-postulacion__wizard-footer-actions">
              <button type="button" class="apap-postulacion__btn apap-postulacion__btn--primary" data-action="back-registration">Volver</button>
            </div>
          </div>
        </div>
      `;
    }

    const members = Array.isArray(team.members) ? team.members : [];
    const identityDocs = Array.isArray(team.identityDocs) ? team.identityDocs : [];
    const paymentLabel = this.isTeamPaid(team) ? 'Pago confirmado' : team.paymentStatus || 'Pendiente';
    const tierLabel = team.declaredTierLabel || (team.declaredTier === 'APAP_PARTNER' ? 'Socio APAP' : 'General');
    const memberCards = members.length
      ? members
          .map((member, index) => {
            const fullName =
              `${member.firstName || ''} ${member.lastName || ''}`.trim() || member.email || `Integrante ${index + 1}`;
            return this.renderCard(
              `Integrante ${index + 1}`,
              `<dl class="apap-postulacion__review-dl">
                ${this.renderReviewRow('Nombre', fullName)}
                ${this.renderReviewRow('Email', member.email)}
                ${this.renderReviewRow('Teléfono', member.phone)}
                ${this.renderReviewRow('Fecha de nacimiento', this.formatBirthDateLabel(member.birthDate))}
                ${this.renderReviewRow('Tipo', this.formatMemberTypeLabel(member))}
                ${this.renderReviewRow('Agencia / centro de estudios', member.agencyName)}
              </dl>`,
              { flat: true },
            );
          })
          .join('')
      : this.renderCard('Integrantes', '<p class="apap-postulacion__item-meta">Sin integrantes cargados.</p>', {
          flat: true,
        });

    const docsBody = identityDocs.length
      ? `<ul class="apap-postulacion__item-meta" style="margin: 0; padding-left: 1.1rem;">
          ${identityDocs
            .map(
              (doc, index) =>
                `<li>${this.escape(doc.label || doc.fileName || `Documento ${index + 1}`)}</li>`,
            )
            .join('')}
        </ul>`
      : '<p class="apap-postulacion__item-meta">Sin documentos de identidad adjuntos.</p>';

    return `
      <div class="apap-postulacion__panel">
        <div class="apap-postulacion__toolbar">
          <div>
            <h2 class="apap-postulacion__toolbar-title">Resumen del registro</h2>
            <p class="apap-postulacion__item-meta">Consulta los datos de tu inscripción confirmada.</p>
          </div>
          <button type="button" class="apap-postulacion__btn apap-postulacion__btn--primary" data-action="back-registration">Volver</button>
        </div>
        <div class="apap-postulacion__alert apap-postulacion__alert--success">Tu inscripción y pago a Jóvenes Talento están confirmados.</div>
        <div class="apap-postulacion__card-stack">
          ${this.renderCard(
            'Datos del equipo',
            `<dl class="apap-postulacion__review-dl">
              ${this.renderReviewRow('Seudónimo', team.pseudonym)}
              ${this.renderReviewRow('Agencia o centro educativo', team.agencyName)}
              ${this.renderReviewRow('Tarifa', tierLabel)}
              ${this.renderReviewRow('Estado del pago', paymentLabel)}
            </dl>`,
          )}
          ${memberCards}
          ${this.renderCard('Documentos de identidad', docsBody)}
        </div>
        <div class="apap-postulacion__wizard-footer">
          <div class="apap-postulacion__wizard-footer-actions">
            <span aria-hidden="true"></span>
            <button type="button" class="apap-postulacion__btn apap-postulacion__btn--primary" data-action="back-registration">Volver</button>
          </div>
        </div>
      </div>
    `;
  }

  renderPaidRegistrationOverviewCard() {
    if (!this.isTeamPaid()) return '';
    const team = this.state.team;
    const members = Array.isArray(team?.members) ? team.members : [];
    const memberNames = members.length
      ? members
          .map((member) => `${member.firstName || ''} ${member.lastName || ''}`.trim() || member.email || 'Integrante')
          .join(', ')
      : 'Sin integrantes';
    const tierLabel = team?.declaredTierLabel || (team?.declaredTier === 'APAP_PARTNER' ? 'Socio APAP' : 'General');

    return this.renderCard(
      'Resumen de tu registro',
      `<dl class="apap-postulacion__review-dl">
        ${this.renderReviewRow('Seudónimo', team?.pseudonym)}
        ${this.renderReviewRow('Tarifa', tierLabel)}
        ${this.renderReviewRow('Integrantes', memberNames)}
        ${this.renderReviewRow('Estado del pago', 'Pago confirmado')}
      </dl>
      <div class="apap-postulacion__wizard-footer-actions" style="margin-top: 1rem;">
        ${this.renderRegistrationSummaryButton()}
      </div>`,
      { hint: 'Puedes consultar el detalle completo de tu inscripción cuando lo necesites.' },
    );
  }

  getPreviewEmail() {
    return String(this.state.participant?.email || this.host?.dataset?.customerEmail || '')
      .trim()
      .toLowerCase();
  }

  canShowPhasePreview() {
    return JT_PHASE_PREVIEW_EMAILS.includes(this.getPreviewEmail());
  }

  buildPreviewMembers() {
    return [
      {
        firstName: 'Ana',
        lastName: 'Pérez',
        email: 'ana.preview@example.com',
        phone: '999111222',
        birthDate: '2000-05-12',
        memberType: 'AGENCY_PRO',
        agencyName: 'Agencia Demo',
        identityFile: null,
        identityFileName: '',
        identityUploaded: true,
      },
      {
        firstName: 'Luis',
        lastName: 'Gómez',
        email: 'luis.preview@example.com',
        phone: '999333444',
        birthDate: '2001-09-03',
        memberType: 'STUDENT',
        agencyName: 'Universidad Demo',
        identityFile: null,
        identityFileName: '',
        identityUploaded: true,
      },
    ];
  }

  buildPreviewTeam({ paid = false, proposalStatus = 'DRAFT', observed = false } = {}) {
    const members = this.buildPreviewMembers().map(
      ({ identityFile, identityFileName, identityUploaded, ...member }) => member,
    );
    const proposal =
      paid || proposalStatus !== 'DRAFT' || observed
        ? {
            status: observed ? 'OBSERVED' : proposalStatus,
            statusLabel: observed
              ? 'Observada'
              : proposalStatus === 'SUBMITTED'
                ? 'Enviada'
                : proposalStatus === 'DRAFT'
                  ? 'Borrador'
                  : proposalStatus,
            format: 'GRAFICA',
            strategyContext: 'Contexto de ejemplo para previsualizar la ficha.',
            strategyInsight: 'Insight de ejemplo.',
            strategyVision: 'Estrategia de ejemplo.',
            verificationNote: observed
              ? 'Debes ajustar el material creativo antes de reenviar.'
              : null,
            mediaAssets: [],
          }
        : null;

    return {
      id: 'preview-team',
      pseudonym: 'Equipo preview',
      paymentStatus: paid || observed || proposalStatus === 'SUBMITTED' ? 'PAID' : 'PENDING',
      declaredTier: 'STANDARD',
      declaredTierLabel: 'General (S/ 275 + IGV)',
      agencyName: 'Agencia Demo',
      members,
      identityDocs: [
        { id: 'preview-doc-1', label: 'DNI — Integrante 1 — Ana Pérez' },
        { id: 'preview-doc-2', label: 'DNI — Integrante 2 — Luis Gómez' },
      ],
      proposal,
    };
  }

  buildPreviewPhase({ enrollmentOpen = true, proposalOpen = false, label = 'Vista previa' } = {}) {
    return {
      phase: proposalOpen ? 'PROPUESTA_ABIERTA' : 'INSCRIPCION_ABIERTA',
      label,
      enrollmentOpen,
      proposalOpen,
      briefOpensAt: '2026-08-05T05:00:00.000Z',
      countdownEndsAt: '2026-08-05T05:00:00.000Z',
      hasCountdown: true,
      proposalClosesAt: '2026-09-15T05:00:00.000Z',
    };
  }

  applyPhasePreview(key) {
    if (!this.canShowPhasePreview()) return;

    if (key === 'real') {
      this.state.previewPhase = null;
      this.state.loading = true;
      this.state.view = 'app';
      this.render();
      void this.bootstrap();
      return;
    }

    const members = this.buildPreviewMembers();
    const base = {
      loading: false,
      authenticated: true,
      previewPhase: key,
      errorMessage: null,
      checkoutConfigured: true,
      partnerAgencies: this.state.partnerAgencies?.length
        ? this.state.partnerAgencies
        : [{ id: 'preview-agency', name: 'Agencia Socia Demo' }],
      participant: this.state.participant || {
        email: this.getPreviewEmail() || 'nicolas@cluster.pe',
        firstName: 'Nicolas',
        lastName: 'Cluster',
      },
      profileForm: this.state.profileForm?.firstName
        ? this.state.profileForm
        : this.buildProfileFormFromParticipant({
            email: 'nicolas@cluster.pe',
            firstName: 'Nicolas',
            lastName: 'Cluster',
            phone: '999000111',
          }),
      members,
      enrollPseudonym: 'Equipo preview',
      enrollAgencyName: 'Agencia Demo',
      enrollPartnerAgencyId: '',
      isApapPartner: false,
    };

    const scenarios = {
      login: {
        ...base,
        view: 'login',
        authenticated: false,
        step: 'enroll',
        team: null,
        brief: null,
        phase: this.buildPreviewPhase({ label: 'Login' }),
      },
      profile: {
        ...base,
        view: 'profile',
        step: 'enroll',
        team: null,
        brief: null,
        phase: this.buildPreviewPhase({ label: 'Perfil' }),
      },
      enroll: {
        ...base,
        view: 'app',
        step: 'enroll',
        team: null,
        brief: null,
        phase: this.buildPreviewPhase({ enrollmentOpen: true, label: 'Inscripciones abiertas' }),
      },
      pay: {
        ...base,
        view: 'app',
        step: 'pay',
        team: this.buildPreviewTeam({ paid: false }),
        brief: null,
        phase: this.buildPreviewPhase({ enrollmentOpen: true, label: 'Pago pendiente' }),
      },
      'brief-pending': {
        ...base,
        view: 'app',
        step: 'brief',
        team: this.buildPreviewTeam({ paid: true }),
        brief: null,
        phase: this.buildPreviewPhase({
          enrollmentOpen: false,
          proposalOpen: false,
          label: 'Brief pendiente',
        }),
      },
      'brief-open': {
        ...base,
        view: 'app',
        step: 'brief',
        team: this.buildPreviewTeam({ paid: true }),
        brief: { id: 'preview-brief', releasedAt: '2026-08-05T05:00:00.000Z' },
        phase: this.buildPreviewPhase({
          enrollmentOpen: false,
          proposalOpen: true,
          label: 'Brief disponible',
        }),
      },
      case: {
        ...base,
        view: 'app',
        step: 'case',
        team: this.buildPreviewTeam({ paid: true, proposalStatus: 'DRAFT' }),
        brief: { id: 'preview-brief', releasedAt: '2026-08-05T05:00:00.000Z' },
        phase: this.buildPreviewPhase({
          enrollmentOpen: false,
          proposalOpen: true,
          label: 'Subir caso',
        }),
      },
      observed: {
        ...base,
        view: 'app',
        step: 'case',
        team: this.buildPreviewTeam({ paid: true, observed: true }),
        brief: { id: 'preview-brief', releasedAt: '2026-08-05T05:00:00.000Z' },
        phase: this.buildPreviewPhase({
          enrollmentOpen: false,
          proposalOpen: true,
          label: 'Observado',
        }),
      },
      done: {
        ...base,
        view: 'app',
        step: 'done',
        team: this.buildPreviewTeam({ paid: true, proposalStatus: 'SUBMITTED' }),
        brief: { id: 'preview-brief', releasedAt: '2026-08-05T05:00:00.000Z' },
        phase: this.buildPreviewPhase({
          enrollmentOpen: false,
          proposalOpen: false,
          label: 'Enviado',
        }),
      },
      registration: {
        ...base,
        view: 'registration-summary',
        step: 'brief',
        registrationReturnStep: 'brief',
        team: this.buildPreviewTeam({ paid: true }),
        brief: null,
        phase: this.buildPreviewPhase({
          enrollmentOpen: false,
          proposalOpen: false,
          label: 'Resumen del registro',
        }),
      },
    };

    const next = scenarios[key];
    if (!next) return;
    this.setState(next);
  }

  ensurePhasePreviewDock() {
    const existing = document.getElementById('apap-jt-phase-preview');
    if (!this.canShowPhasePreview()) {
      existing?.remove();
      return;
    }

    if (!existing) {
      const dock = document.createElement('aside');
      dock.id = 'apap-jt-phase-preview';
      dock.className = 'apap-jt-phase-preview';
      dock.setAttribute('aria-label', 'Preview de fases JT');
      dock.innerHTML = `
        <p class="apap-jt-phase-preview__title">Fases JT</p>
        <div class="apap-jt-phase-preview__actions">
          ${JT_PHASE_PREVIEW_OPTIONS.map(
            (option) =>
              `<button type="button" class="apap-jt-phase-preview__btn" data-jt-preview-phase="${this.escapeAttr(option.key)}">${this.escape(option.label)}</button>`,
          ).join('')}
        </div>
      `;
      document.body.appendChild(dock);
      dock.addEventListener('click', (event) => {
        const button = event.target instanceof Element ? event.target.closest('[data-jt-preview-phase]') : null;
        if (!(button instanceof HTMLButtonElement)) return;
        this.applyPhasePreview(button.getAttribute('data-jt-preview-phase'));
      });
    }

    const dock = document.getElementById('apap-jt-phase-preview');
    if (!dock) return;
    dock.querySelectorAll('[data-jt-preview-phase]').forEach((button) => {
      const active = button.getAttribute('data-jt-preview-phase') === this.state.previewPhase;
      button.classList.toggle('is-active', active);
    });
  }

  start() {
    void this.bootstrap();
  }

  querySelector(selector) {
    return this.host.querySelector(selector);
  }

  querySelectorAll(selector) {
    return this.host.querySelectorAll(selector);
  }

  setHostHtml(html) {
    this.host.innerHTML = html;
  }

  escape(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  escapeAttr(value) {
    return this.escape(value).replace(/'/g, '&#39;');
  }

  async apiFetch(path, options = {}) {
    const url = `${this.apiBase}${path.startsWith('/') ? path : `/${path}`}`;
    const response = await fetch(url, {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        ...(options.body ? { 'Content-Type': 'application/json' } : {}),
        ...(options.headers || {}),
      },
      ...options,
    });
    const payload = await response.json().catch(() => null);
    if (!payload) {
      throw Object.assign(new Error(`Error del servidor (${response.status}).`), { code: 'SERVER_ERROR' });
    }
    if (!payload.ok) {
      const error = new Error(payload.error?.message || 'Error de API');
      error.code = payload.error?.code;
      throw error;
    }
    return payload.data;
  }

  async uploadFile(body, file, onProgress) {
    const initResponse = await fetch(`${this.uploadBase}/upload`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    const init = await initResponse.json().catch(() => null);
    if (!init?.assetId) {
      const message = init?.error || 'No se pudo iniciar la subida';
      throw new Error(message);
    }

    const confirmUrl = this.resolveMediaUrl(init.confirmUrl || '/api/upload/confirm');
    const abortUrl = this.resolveMediaUrl(init.abortUrl || '/api/upload/abort');

    try {
      if (init.directUploadUrl) {
        await new Promise((resolve, reject) => {
          const xhr = new XMLHttpRequest();
          xhr.open('PUT', init.directUploadUrl);
          xhr.upload.onprogress = (event) => {
            if (!event.lengthComputable || typeof onProgress !== 'function') return;
            onProgress(Math.round((event.loaded / event.total) * 100));
          };
          xhr.onload = () => {
            if (xhr.status >= 200 && xhr.status < 300) {
              resolve();
              return;
            }
            reject(new Error('No se pudo subir el archivo.'));
          };
          xhr.onerror = () => reject(new Error('No se pudo subir el archivo.'));
          file.arrayBuffer().then((body) => xhr.send(body), reject);
        });
        const confirmRes = await fetch(confirmUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ assetId: init.assetId, fileKey: init.fileKey }),
        });
        if (!confirmRes.ok) {
          throw new Error('No se pudo confirmar la subida.');
        }
      } else {
        await new Promise((resolve, reject) => {
          const xhr = new XMLHttpRequest();
          xhr.open('POST', `${this.uploadBase}/upload/file/${init.assetId}`);
          xhr.withCredentials = true;
          xhr.upload.onprogress = (event) => {
            if (!event.lengthComputable || typeof onProgress !== 'function') return;
            onProgress(Math.round((event.loaded / event.total) * 100));
          };
          xhr.onload = () => {
            if (xhr.status >= 200 && xhr.status < 300) {
              resolve();
              return;
            }
            reject(new Error('No se pudo subir el archivo.'));
          };
          xhr.onerror = () => reject(new Error('No se pudo subir el archivo.'));
          const form = new FormData();
          form.append('file', file);
          xhr.send(form);
        });
      }
    } catch (error) {
      await fetch(abortUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ assetId: init.assetId }),
      }).catch(() => {});
      throw error;
    }
  }

  resolveMediaUrl(path) {
    if (!path) return path;
    if (path.startsWith('http')) return path;
    if (path.startsWith('/apps/')) return path;
    if (path.startsWith('/proxy/')) {
      const prefix = this.uploadBase.replace(/\/api$/, '');
      return `${prefix}${path}`;
    }
    if (path.startsWith('/api/')) return `${this.uploadBase}${path.replace(/^\/api/, '')}`;
    return path;
  }

  async refreshTeam() {
    const dashboard = await this.apiFetch('/jovenes-talento/dashboard');
    this.state.team = dashboard.team;
    this.state.brief = dashboard.brief;
    this.state.phase = dashboard.phase;
    this.state.edition = dashboard.edition;
    return dashboard;
  }

  setState(next) {
    this.state = { ...this.state, ...next };
    this.render();
  }

  getCountdownRemaining(closesAt) {
    const total = new Date(closesAt).getTime() - Date.now();
    if (total <= 0) {
      return { total: 0, days: 0, hours: 0, minutes: 0, seconds: 0 };
    }
    return {
      total,
      days: Math.floor(total / (1000 * 60 * 60 * 24)),
      hours: Math.floor((total / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((total / (1000 * 60)) % 60),
      seconds: Math.floor((total / 1000) % 60),
    };
  }

  padCountdown(value) {
    return String(value).padStart(2, '0');
  }

  renderCountdownUnits(remaining) {
    const units = [
      { label: 'Días', value: String(remaining.days) },
      { label: 'Horas', value: this.padCountdown(remaining.hours) },
      { label: 'Min', value: this.padCountdown(remaining.minutes) },
      { label: 'Seg', value: this.padCountdown(remaining.seconds) },
    ];
    return units
      .map(
        (unit, index) => `
          <div class="apap-postulacion__countdown-unit">
            ${index > 0 ? '<span class="apap-postulacion__countdown-separator" aria-hidden="true">:</span>' : ''}
            <span class="apap-postulacion__countdown-value">${this.escape(unit.value)}</span>
            <span class="apap-postulacion__countdown-label">${this.escape(unit.label)}</span>
          </div>
        `,
      )
      .join('');
  }

  countdownEyebrow() {
    const phase = this.state.phase?.phase;
    if (phase === 'INSCRIPCION_CERRADA') return 'Abre en';
    if (phase === 'REVISION_ABIERTA') return 'Revisión cierra en';
    return 'Cierra en';
  }

  isProposalWindowUpcoming() {
    const phase = this.state.phase?.phase;
    return phase === 'INSCRIPCION_ABIERTA' || phase === 'INSCRIPCION_CERRADA';
  }

  isProposalWindowClosed() {
    const phase = this.state.phase?.phase;
    if (!phase || phase === 'PROPUESTA_ABIERTA') return false;
    return !this.isProposalWindowUpcoming();
  }

  renderProposalWindowAlert(proposal) {
    if (this.state.phase?.proposalOpen === true || proposal.status !== 'DRAFT') return '';
    if (this.isProposalWindowClosed()) {
      const phaseLabel = this.state.phase?.label || 'revisión de material';
      return `<div class="apap-postulacion__alert apap-postulacion__alert--warning">La ventana para subir tu caso ya cerró. Fase actual: ${this.escape(phaseLabel)}.</div>`;
    }
    return `<div class="apap-postulacion__alert apap-postulacion__alert--warning">La ventana para subir tu caso aún no está abierta. Puedes preparar tu borrador cuando se habilite.</div>`;
  }

  renderCountdownBlock({ endsAt, eyebrow, closedLabel }) {
    if (!endsAt) return '';
    const remaining = this.getCountdownRemaining(endsAt);
    if (remaining.total <= 0) return '';
    return `
      <div
        class="apap-postulacion__countdown"
        data-countdown
        data-closes-at="${this.escapeAttr(endsAt)}"
        data-closed-label="${this.escapeAttr(closedLabel || 'Etapa cerrada')}"
        data-eyebrow="${this.escapeAttr(eyebrow || 'Cierra en')}"
        aria-live="polite"
      >
        <p class="apap-postulacion__countdown-eyebrow">${this.escape(eyebrow || 'Cierra en')}</p>
        <div class="apap-postulacion__countdown-grid" data-countdown-live></div>
      </div>
    `;
  }

  renderEditionCountdown() {
    const phase = this.state.phase;
    if (!phase?.countdownEndsAt || phase.hasCountdown === false) return '';
    return this.renderCountdownBlock({
      endsAt: phase.countdownEndsAt,
      eyebrow: this.countdownEyebrow(),
      closedLabel: phase.label || 'Etapa cerrada',
    });
  }

  renderEnrollmentCountdown() {
    const phase = this.state.phase || {};
    const endsAt = phase.enrollmentClosesAt || phase.countdownEndsAt;
    if (!endsAt) return '';
    return this.renderCountdownBlock({
      endsAt,
      eyebrow: 'Cierra en',
      closedLabel: 'Inscripciones cerradas',
    });
  }

  renderBriefCountdown(briefAvailable) {
    const phase = this.state.phase || {};
    if (briefAvailable) {
      return this.renderCountdownBlock({
        endsAt: phase.proposalClosesAt || phase.countdownEndsAt,
        eyebrow: 'Cierra en',
        closedLabel: phase.label || 'Postulación cerrada',
      });
    }
    return this.renderCountdownBlock({
      endsAt: phase.briefOpensAt,
      eyebrow: 'Abre en',
      closedLabel: 'Brief disponible',
    });
  }

  updateCountdownElements() {
    let hasActiveCountdown = false;
    this.querySelectorAll('[data-countdown]').forEach((root) => {
      const closesAt = root.getAttribute('data-closes-at');
      if (!closesAt) return;
      const closedLabel = root.getAttribute('data-closed-label') || 'Etapa cerrada';
      const eyebrow = root.getAttribute('data-eyebrow') || 'Cierra en';
      const remaining = this.getCountdownRemaining(closesAt);
      if (remaining.total <= 0) {
        root.classList.add('apap-postulacion__countdown--closed');
        root.innerHTML = `<p class="apap-postulacion__countdown-closed">${this.escape(closedLabel)}</p>`;
        return;
      }
      hasActiveCountdown = true;
      root.classList.remove('apap-postulacion__countdown--closed');
      const live = root.querySelector('[data-countdown-live]');
      if (live) {
        live.innerHTML = this.renderCountdownUnits(remaining);
      } else {
        root.innerHTML = `
          <p class="apap-postulacion__countdown-eyebrow">${this.escape(eyebrow)}</p>
          <div class="apap-postulacion__countdown-grid" data-countdown-live>${this.renderCountdownUnits(remaining)}</div>
        `;
      }
    });
    if (!hasActiveCountdown) {
      this.stopCountdownTimer();
    }
  }

  stopCountdownTimer() {
    if (this._countdownTimer) {
      window.clearInterval(this._countdownTimer);
      this._countdownTimer = null;
    }
  }

  startCountdownTimer() {
    this.stopCountdownTimer();
    if (!this.querySelector('[data-countdown]')) return;
    this.updateCountdownElements();
    this._countdownTimer = window.setInterval(() => this.updateCountdownElements(), 1000);
  }

  renderCard(title, body, { hint, flat, required = false } = {}) {
    const titleMarkup = title
      ? `${this.escape(title)}${required ? '<span class="apap-postulacion__required" aria-hidden="true">*</span>' : ''}`
      : '';
    return `
      <section class="apap-postulacion__card${flat ? ' apap-postulacion__card--flat' : ''}">
        ${
          title
            ? `<header class="apap-postulacion__card-header">
            <h3 class="apap-postulacion__card-title">${titleMarkup}</h3>
            ${hint ? `<p class="apap-postulacion__card-hint">${this.escape(hint)}</p>` : ''}
          </header>`
            : ''
        }
        <div class="apap-postulacion__card-body">${body}</div>
      </section>
    `;
  }

  renderFieldLabel(label, { required = false } = {}) {
    return `<label class="apap-postulacion__label">${this.escape(label)}${
      required ? '<span class="apap-postulacion__required" aria-hidden="true">*</span>' : ''
    }</label>`;
  }

  renderTextField(
    name,
    label,
    value,
    { required = false, type = 'text', maxlength = null, placeholder = null, pattern = null } = {},
  ) {
    const attrs = [
      required ? 'required' : '',
      type && type !== 'text' ? `type="${type}"` : '',
      maxlength ? `maxlength="${maxlength}"` : '',
      placeholder ? `placeholder="${this.escapeAttr(placeholder)}"` : '',
      pattern ? `pattern="${this.escapeAttr(pattern)}"` : '',
    ]
      .filter(Boolean)
      .join(' ');
    return `<div class="apap-postulacion__field">${this.renderFieldLabel(label, { required })}<input class="apap-postulacion__input" name="${this.escapeAttr(name)}" value="${this.escapeAttr(value ?? '')}" ${attrs}></div>`;
  }

  renderSelectField(name, label, value, options, { required = false, attrs = '' } = {}) {
    return `<div class="apap-postulacion__field">${this.renderFieldLabel(label, { required })}<select class="apap-postulacion__select" name="${this.escapeAttr(name)}" ${required ? 'required' : ''} ${attrs}>${options
      .map(
        (option) =>
          `<option value="${this.escapeAttr(option.value)}" ${value === option.value ? 'selected' : ''}>${this.escape(option.label)}</option>`,
      )
      .join('')}</select></div>`;
  }

  renderPartnerAgencySelect(selectedId = '', { required = false } = {}) {
    const agencies = Array.isArray(this.state.partnerAgencies) ? this.state.partnerAgencies : [];
    const options = [
      { value: '', label: 'Selecciona tu agencia socia' },
      ...agencies.map((agency) => ({ value: agency.id, label: agency.name })),
    ];
    return this.renderSelectField('partnerAgencyId', 'Agencia socia APAP', selectedId, options, {
      required,
      attrs: 'data-jt-partner-select',
    });
  }

  renderTeamAgencyFields() {
    const isPartner = this.state.isApapPartner === true;
    const tierValue = isPartner ? 'APAP_PARTNER' : 'STANDARD';
    const tierLabel = isPartner ? 'Socio APAP (S/ 220 + IGV)' : 'General (S/ 275 + IGV)';
    const pseudonym = this.state.enrollPseudonym || '';
    const agencyName = this.state.enrollAgencyName || '';
    const partnerAgencyId = this.state.enrollPartnerAgencyId || '';

    return `
      <div class="apap-postulacion__field-grid apap-postulacion__field-grid--2">
        ${this.renderTextField('pseudonym', 'Seudónimo del equipo', pseudonym, { required: true, maxlength: 80 })}
      </div>
      <fieldset class="apap-postulacion__field">
        <legend class="apap-postulacion__label">¿Tu agencia es socia APAP?<span class="apap-postulacion__required" aria-hidden="true">*</span></legend>
        <div class="apap-postulacion__radio-row">
          <label class="apap-postulacion__radio">
            <input type="radio" name="isApapPartner" value="true" data-jt-partner-toggle ${isPartner ? 'checked' : ''}>
            <span>Sí</span>
          </label>
          <label class="apap-postulacion__radio">
            <input type="radio" name="isApapPartner" value="false" data-jt-partner-toggle ${!isPartner ? 'checked' : ''}>
            <span>No</span>
          </label>
        </div>
      </fieldset>
      <div data-jt-partner-fields ${isPartner ? '' : 'hidden'}>
        ${this.renderPartnerAgencySelect(partnerAgencyId, { required: isPartner })}
      </div>
      <div data-jt-non-partner-fields ${isPartner ? 'hidden' : ''}>
        ${this.renderTextField('agencyName', 'Agencia o centro educativo (opcional)', agencyName, { maxlength: 120 })}
      </div>
      <div class="apap-postulacion__field" data-jt-tier-display>
        ${this.renderFieldLabel('Tarifa aplicable')}
        <p class="apap-postulacion__item-meta" data-jt-tier-label>${this.escape(tierLabel)}</p>
        <input type="hidden" name="declaredTier" value="${this.escapeAttr(tierValue)}" data-jt-tier-input>
      </div>
    `;
  }

  syncEnrollPartnerFields(form) {
    if (!(form instanceof HTMLFormElement)) return;
    const isPartner = Boolean(form.querySelector('input[name="isApapPartner"][value="true"]')?.checked);
    const partnerFields = form.querySelector('[data-jt-partner-fields]');
    const nonPartnerFields = form.querySelector('[data-jt-non-partner-fields]');
    const partnerSelect = form.querySelector('[data-jt-partner-select]');
    const tierInput = form.querySelector('[data-jt-tier-input]');
    const tierLabel = form.querySelector('[data-jt-tier-label]');

    if (partnerFields) partnerFields.hidden = !isPartner;
    if (nonPartnerFields) nonPartnerFields.hidden = isPartner;
    if (partnerSelect instanceof HTMLSelectElement) {
      partnerSelect.required = isPartner;
      if (!isPartner) partnerSelect.value = '';
    }

    const nextTier = isPartner ? 'APAP_PARTNER' : 'STANDARD';
    if (tierInput instanceof HTMLInputElement) tierInput.value = nextTier;
    if (tierLabel) {
      tierLabel.textContent = isPartner ? 'Socio APAP (S/ 220 + IGV)' : 'General (S/ 275 + IGV)';
    }
    this.state.isApapPartner = isPartner;
  }

  resolveEnrollAgencyPayload(form) {
    const isPartner = Boolean(form.querySelector('input[name="isApapPartner"][value="true"]')?.checked);
    if (isPartner) {
      const select = form.querySelector('[data-jt-partner-select]');
      const partnerAgencyId = select instanceof HTMLSelectElement ? select.value.trim() : '';
      if (!partnerAgencyId) {
        throw new Error('Selecciona la agencia socia APAP a la que pertenece el equipo.');
      }
      const agency = (this.state.partnerAgencies || []).find((item) => item.id === partnerAgencyId);
      const agencyName =
        agency?.name ||
        (select instanceof HTMLSelectElement ? select.selectedOptions?.[0]?.textContent?.trim() : '') ||
        '';
      if (!agencyName) {
        throw new Error('Selecciona una agencia socia APAP válida.');
      }
      return { declaredTier: 'APAP_PARTNER', agencyName, partnerAgencyId };
    }

    return {
      declaredTier: 'STANDARD',
      agencyName: form.querySelector('[name="agencyName"]')?.value?.trim() || '',
      partnerAgencyId: null,
    };
  }

  renderTextarea(name, label, value, { required = false, rows = 4, attrs = '' } = {}) {
    return `<div class="apap-postulacion__field">${this.renderFieldLabel(label, { required })}<textarea class="apap-postulacion__textarea" name="${this.escapeAttr(name)}" rows="${rows}" ${required ? 'required' : ''} ${attrs}>${this.escape(value ?? '')}</textarea></div>`;
  }

  renderWizardSteps(currentStepIndex) {
    return `
      <ol class="apap-postulacion__wizard-track">
        ${WIZARD_STEPS.map((wizardStep) => {
          const isActive = wizardStep.id === currentStepIndex;
          const isDone = wizardStep.id < currentStepIndex;
          const stateClass = isActive ? ' is-active' : isDone ? ' is-done' : ' is-pending';
          return `
            <li class="apap-postulacion__wizard-step-item${stateClass}">
              <span class="apap-postulacion__wizard-step-btn" aria-current="${isActive ? 'step' : 'false'}">
                <span class="apap-postulacion__wizard-step-circle" aria-hidden="true">
                  <span class="apap-postulacion__wizard-step-check">✓</span>
                  <span class="apap-postulacion__wizard-step-number">${wizardStep.id}</span>
                </span>
                <span class="apap-postulacion__wizard-step-label">${this.escape(wizardStep.label)}</span>
              </span>
            </li>
          `;
        }).join('')}
      </ol>
    `;
  }

  buildProfileFormFromParticipant(participant) {
    const p = participant ?? {};
    const dataset = this.host?.dataset ?? {};
    const isApapPartner = typeof p.isApapPartner === 'boolean' ? p.isApapPartner : false;
    let firstName = p.firstName || dataset.customerFirstName || '';
    let lastName = p.lastName || dataset.customerLastName || '';
    if (!firstName && !lastName) {
      const fullName = String(dataset.customerName ?? '').trim();
      if (fullName) {
        const parts = fullName.split(/\s+/);
        firstName = parts[0] || '';
        lastName = parts.slice(1).join(' ');
      }
    }
    return {
      firstName,
      lastName,
      organization: p.organization || '',
      phone: p.phone || dataset.customerPhone || '',
      ruc: p.ruc || '',
      razonSocial: p.razonSocial || '',
      isApapPartner,
      partnerAgencyId: p.partnerAgencyId || '',
      invoiceEmail: p.invoiceEmail || '',
      invoiceContactName: p.invoiceContactName || '',
    };
  }

  renderProfilePartnerAgencySelect(selectedId = '', selectedLabel = '') {
    const list = Array.isArray(this.state.partnerAgencies) ? [...this.state.partnerAgencies] : [];
    if (selectedId && !list.some((agency) => agency.id === selectedId)) {
      list.unshift({
        id: selectedId,
        name: selectedLabel || selectedId,
      });
    }
    const options = [
      { value: '', label: 'Selecciona tu agencia socia' },
      ...list.map((agency) => ({ value: agency.id, label: agency.name })),
    ];
    return this.renderSelectField('partnerAgencyId', 'Agencia socia APAP', selectedId, options, {
      required: true,
      attrs: 'data-profile-partner-select',
    });
  }

  renderProfile() {
    const f = this.state.profileForm || emptyProfileForm();
    const isPartner = Boolean(f.isApapPartner);
    return `
      <div class="apap-postulacion__panel">
        <div class="apap-postulacion__toolbar">
          <div>
            <h2 class="apap-postulacion__toolbar-title">Completa tu perfil</h2>
            <p class="apap-postulacion__item-meta">Confirma tus datos de agencia para continuar con Jóvenes Talento.</p>
          </div>
        </div>
        <form class="apap-postulacion__form" data-form="profile">
          <div class="apap-postulacion__card-stack">
            ${this.renderCard(
              'Datos personales',
              `<div class="apap-postulacion__field-grid apap-postulacion__field-grid--2">
                ${this.renderTextField('firstName', 'Nombre', f.firstName, { required: true })}
                ${this.renderTextField('lastName', 'Apellido', f.lastName, { required: true })}
                ${this.renderTextField('phone', 'Teléfono', f.phone, { required: true })}
              </div>`,
            )}
            ${this.renderCard(
              'Datos de agencia',
              `<fieldset class="apap-postulacion__field">
                <legend class="apap-postulacion__label">¿Tu agencia es socia APAP?</legend>
                <div class="apap-postulacion__radio-row">
                  <label class="apap-postulacion__radio">
                    <input type="radio" name="isApapPartner" value="true" data-profile-partner-toggle ${isPartner ? 'checked' : ''}>
                    <span>Sí</span>
                  </label>
                  <label class="apap-postulacion__radio">
                    <input type="radio" name="isApapPartner" value="false" data-profile-partner-toggle ${!isPartner ? 'checked' : ''}>
                    <span>No</span>
                  </label>
                </div>
              </fieldset>
              <div data-profile-partner-fields ${isPartner ? '' : 'hidden'}>
                ${this.renderProfilePartnerAgencySelect(f.partnerAgencyId, f.organization)}
              </div>
              <div data-profile-non-partner-fields ${isPartner ? 'hidden' : ''}>
                <div class="apap-postulacion__field-grid apap-postulacion__field-grid--2">
                  ${this.renderTextField('organization', 'Nombre de la agencia', f.organization, { required: !isPartner })}
                  ${this.renderTextField('ruc', 'RUC', f.ruc, { required: !isPartner, pattern: '\\d{11}' })}
                  ${this.renderTextField('razonSocial', 'Razón social', f.razonSocial, { required: !isPartner })}
                </div>
              </div>`,
            )}
            ${this.renderCard(
              'Facturación',
              `<p class="apap-postulacion__item-meta">Indica a quién debe enviarse la factura de tus inscripciones.</p>
              <div class="apap-postulacion__field-grid apap-postulacion__field-grid--2">
                ${this.renderTextField('invoiceEmail', 'Correo de facturación', f.invoiceEmail, {
                  type: 'email',
                  placeholder: 'contabilidad@agencia.com',
                })}
                ${this.renderTextField('invoiceContactName', 'Contacto de facturación', f.invoiceContactName, {
                  placeholder: 'Área de contabilidad o persona responsable',
                })}
              </div>`,
              { hint: 'La factura se enviará al correo de facturación. El contacto es opcional.' },
            )}
          </div>
          <div data-profile-error></div>
          <div class="apap-postulacion__wizard-footer">
            <div class="apap-postulacion__wizard-footer-actions">
              <span></span>
              <button type="submit" class="apap-postulacion__btn apap-postulacion__btn--primary">Guardar y continuar</button>
            </div>
          </div>
        </form>
      </div>
    `;
  }

  syncProfilePartnerFields(form) {
    if (!(form instanceof HTMLFormElement)) return;
    const isPartner = Boolean(form.querySelector('input[name="isApapPartner"][value="true"]')?.checked);
    const partnerFields = form.querySelector('[data-profile-partner-fields]');
    const nonPartnerFields = form.querySelector('[data-profile-non-partner-fields]');
    const partnerSelect = form.querySelector('[data-profile-partner-select]');
    const nonPartnerInputs = form.querySelectorAll('[data-profile-non-partner-fields] [name]');

    if (partnerFields) partnerFields.hidden = !isPartner;
    if (nonPartnerFields) nonPartnerFields.hidden = Boolean(isPartner);
    if (partnerSelect instanceof HTMLSelectElement) {
      partnerSelect.required = isPartner;
      if (!isPartner) partnerSelect.removeAttribute('required');
    }
    nonPartnerInputs.forEach((input) => {
      if (!(input instanceof HTMLInputElement || input instanceof HTMLSelectElement || input instanceof HTMLTextAreaElement)) {
        return;
      }
      if (isPartner) {
        input.removeAttribute('required');
      } else {
        input.required = true;
      }
    });
  }

  collectProfileFormBody(formData) {
    const isApapPartner = formData.get('isApapPartner') === 'true';
    return {
      firstName: String(formData.get('firstName') ?? '').trim(),
      lastName: String(formData.get('lastName') ?? '').trim(),
      phone: String(formData.get('phone') ?? '').trim(),
      isApapPartner,
      partnerAgencyId: isApapPartner ? String(formData.get('partnerAgencyId') ?? '').trim() : '',
      organization: isApapPartner ? '' : String(formData.get('organization') ?? '').trim(),
      ruc: isApapPartner ? '' : String(formData.get('ruc') ?? '').trim(),
      razonSocial: isApapPartner ? '' : String(formData.get('razonSocial') ?? '').trim(),
      invoiceEmail: String(formData.get('invoiceEmail') ?? '').trim(),
      invoiceContactName: String(formData.get('invoiceContactName') ?? '').trim(),
    };
  }

  showProfileError(message) {
    const errorEl = this.querySelector('[data-profile-error]');
    if (!errorEl) return;
    errorEl.innerHTML = message
      ? `<div class="apap-postulacion__alert apap-postulacion__alert--error">${this.escape(message)}</div>`
      : '';
  }

  async loadPartnerAgencies() {
    try {
      const agenciesPayload = await this.apiFetch('/partner-agencies');
      return Array.isArray(agenciesPayload?.agencies) ? agenciesPayload.agencies : [];
    } catch {
      return [];
    }
  }

  async showProfileOnboarding(participant) {
    const partnerAgencies = await this.loadPartnerAgencies();
    this.setState({
      loading: false,
      view: 'profile',
      authenticated: true,
      participant: participant || null,
      partnerAgencies,
      profileForm: this.buildProfileFormFromParticipant(participant),
      step: 'enroll',
      team: null,
      brief: null,
    });
  }

  async enterYouthApp(participant = this.state.participant) {
    const dashboard = await this.apiFetch('/jovenes-talento/dashboard');
    const team = dashboard.team;
    const step = resolveWizardStep(team, dashboard.brief);
    let partnerAgencies = this.state.partnerAgencies;
    if (!Array.isArray(partnerAgencies) || !partnerAgencies.length) {
      partnerAgencies = await this.loadPartnerAgencies();
    }
    this.setState({
      loading: false,
      view: 'app',
      authenticated: true,
      participant: participant || this.state.participant,
      team,
      brief: dashboard.brief,
      edition: dashboard.edition,
      step,
      phase: dashboard.phase,
      checkoutConfigured: dashboard.checkoutConfigured !== false,
      partnerAgencies,
      isApapPartner: false,
      members: team?.members?.length
        ? team.members.map((member, index) => ({
            firstName: member.firstName || '',
            lastName: member.lastName || '',
            email: member.email || '',
            phone: member.phone || '',
            birthDate: member.birthDate?.slice?.(0, 10) || member.birthDate || '',
            memberType: member.memberType || 'AGENCY_PRO',
            agencyName: member.agencyName || '',
            identityFile: null,
            identityFileName: '',
            identityUploaded: index < (team.identityDocs?.length || 0),
          }))
        : [emptyMember(), emptyMember()],
    });
  }

  async handleProfileSubmit(form) {
    this.showProfileError('');
    const button = form.querySelector('[type="submit"]');
    if (button instanceof HTMLButtonElement) button.disabled = true;
    try {
      const body = this.collectProfileFormBody(new FormData(form));
      const data = await this.apiFetch('/profile', {
        method: 'PUT',
        body: JSON.stringify(body),
      });
      this.state.participant = data.participant;
      this.state.profileForm = this.buildProfileFormFromParticipant(data.participant);
      await this.enterYouthApp(data.participant);
    } catch (error) {
      this.showProfileError(error instanceof Error ? error.message : 'No se pudo guardar tu perfil.');
    } finally {
      if (button instanceof HTMLButtonElement) button.disabled = false;
    }
  }

  renderLogin() {
    const returnUrl = encodeURIComponent(this.loginRedirect || window.location.href);
    const href = `${this.loginUrl}${this.loginUrl.includes('?') ? '&' : '?'}return_url=${returnUrl}`;
    return `
      <div class="apap-postulacion__panel">
        ${this.renderCard(
          'Inicia sesión o crea una cuenta de usuario',
          `<a class="apap-postulacion__btn apap-postulacion__btn--primary" href="${this.escapeAttr(href)}">Iniciar sesión</a>`,
          { hint: 'Necesitas una cuenta activa para poder inscribirte.' },
        )}
      </div>
    `;
  }

  renderLoading() {
    return `
      <div class="apap-postulacion__loading" aria-live="polite">
        <p class="apap-postulacion__loading-text">Cargando inscripción…</p>
      </div>
    `;
  }

  renderMemberFields(member, index) {
    const hasIdentityFile = Boolean(member.identityFileName) || member.identityUploaded;
    const identityHint = member.identityUploaded && !member.identityFileName
      ? `<p class="apap-postulacion__field-hint">Documento ya cargado. Puedes reemplazarlo si lo necesitas.</p>`
      : member.identityFileName
        ? `<p class="apap-postulacion__field-hint">Archivo listo: <strong>${this.escape(member.identityFileName)}</strong>. Puedes reemplazarlo si lo necesitas.</p>`
        : `<p class="apap-postulacion__field-hint">PDF o imagen del DNI de este integrante.</p>`;

    return `
      <div class="apap-postulacion__field-grid apap-postulacion__field-grid--2">
        ${this.renderTextField(`member_${index}_firstName`, 'Nombres', member.firstName, { required: true })}
        ${this.renderTextField(`member_${index}_lastName`, 'Apellidos', member.lastName, { required: true })}
        ${this.renderTextField(`member_${index}_email`, 'Email', member.email, { required: true, type: 'email' })}
        ${this.renderTextField(`member_${index}_phone`, 'Teléfono', member.phone)}
        ${this.renderTextField(`member_${index}_birthDate`, 'Fecha de nacimiento', member.birthDate, { required: true, type: 'date' })}
        ${this.renderSelectField(`member_${index}_memberType`, 'Tipo', member.memberType, MEMBER_TYPES, { required: true })}
        ${this.renderTextField(`member_${index}_agencyName`, 'Agencia / centro de estudios', member.agencyName)}
      </div>
      <div class="apap-postulacion__field" style="margin-top: 0.75rem;">
        ${this.renderFieldLabel('Documento de identidad (DNI)', { required: !hasIdentityFile })}
        <input
          class="apap-postulacion__input"
          type="file"
          name="member_${index}_identityDoc"
          accept="application/pdf,image/*"
          ${hasIdentityFile ? '' : 'required'}
        />
        ${identityHint}
      </div>
    `;
  }

  renderMemberCard(member, index, totalMembers) {
    const canRemove = totalMembers > MIN_MEMBERS;
    const removeButton = canRemove
      ? `<button type="button" class="apap-postulacion__btn apap-postulacion__btn--secondary" data-action="remove-member" data-member-index="${index}">Quitar integrante</button>`
      : '';
    const body = `${this.renderMemberFields(member, index)}${
      removeButton ? `<div class="apap-postulacion__field" style="margin-top: 0.75rem;">${removeButton}</div>` : ''
    }`;
    return this.renderCard(`Integrante ${index + 1}`, body, { flat: true });
  }

  renderMembersSection() {
    const members = this.state.members?.length ? this.state.members : [emptyMember(), emptyMember()];
    const memberCards = members.map((member, index) => this.renderMemberCard(member, index, members.length)).join('');
    const canAdd = members.length < MAX_MEMBERS;
    const addButton = canAdd
      ? `<div class="apap-postulacion__field">
          <button type="button" class="apap-postulacion__btn apap-postulacion__btn--secondary" data-action="add-member">
            Agregar integrante (${members.length}/${MAX_MEMBERS})
          </button>
        </div>`
      : `<p class="apap-postulacion__item-meta">Máximo de ${MAX_MEMBERS} integrantes alcanzado.</p>`;

    return `
      <div class="apap-postulacion__card-stack">
        ${memberCards}
        ${addButton}
      </div>
    `;
  }

  renderLegalLink(href, label) {
    if (!href || href === '#') return this.escape(label);
    return `<a href="${this.escapeAttr(href)}" target="_blank" rel="noopener noreferrer">${this.escape(label)}</a>`;
  }

  renderLegalAcceptance() {
    return `
      <section class="apap-postulacion__legal-acceptance" aria-labelledby="jt-legal-heading">
        <h3 id="jt-legal-heading" class="apap-postulacion__legal-acceptance-title">Declaraciones obligatorias</h3>
        <div class="apap-postulacion__legal-acceptance-options">
          <label class="apap-postulacion__legal-acceptance-option">
            <input type="checkbox" name="legalAccepted" required />
            <span>
              Acepto las <a href="${this.escapeAttr(this.basesUrl)}" target="_blank" rel="noopener">bases de Jóvenes Talentos</a>.
              <span class="apap-postulacion__required" aria-hidden="true"> *</span>
            </span>
          </label>
        </div>
      </section>
    `;
  }

  renderCaseLegalAcceptance() {
    return `
      <section class="apap-postulacion__legal-acceptance" aria-labelledby="jt-case-legal-heading">
        <h3 id="jt-case-legal-heading" class="apap-postulacion__legal-acceptance-title">Declaraciones obligatorias</h3>
        <div class="apap-postulacion__legal-acceptance-options">
          <label class="apap-postulacion__legal-acceptance-option">
            <input type="checkbox" name="${ACCEPT_TERMS_FIELD}" required />
            <span>
              Acepto los ${this.renderLegalLink(this.termsUrl, 'términos y condiciones')} y las ${this.renderLegalLink(this.basesUrl, 'bases de Jóvenes Talentos')}.
              <span class="apap-postulacion__required" aria-hidden="true"> *</span>
            </span>
          </label>
          <label class="apap-postulacion__legal-acceptance-option">
            <input type="checkbox" name="${ACCEPT_PRIVACY_FIELD}" required />
            <span>
              Acepto las ${this.renderLegalLink(this.privacyUrl, 'políticas de privacidad')}.
              <span class="apap-postulacion__required" aria-hidden="true"> *</span>
            </span>
          </label>
        </div>
      </section>
    `;
  }

  renderEnrollmentClosed() {
    const phaseLabel = this.state.phase?.label || 'etapa actual';
    return `
      <div class="apap-postulacion__panel">
        <div class="apap-postulacion__toolbar">
          <div class="apap-postulacion__toolbar-head">
            <div>
              <h2 class="apap-postulacion__toolbar-title">Inscripciones cerradas</h2>
              <p class="apap-postulacion__item-meta">${this.escape(phaseLabel)}</p>
            </div>
            ${this.renderBriefCountdown(this.state.phase?.proposalOpen === true)}
          </div>
        </div>
        ${this.renderCard(
          '',
          `<div class="apap-postulacion__alert apap-postulacion__alert--info">
            <p style="margin: 0;">Las inscripciones ya finalizaron.</p>
            <p style="margin: 0.75rem 0 0;">Si perteneces a un equipo, debes descargar el brief y enviar tu propuesta desde la cuenta del usuario que se registró e hizo el pago.</p>
          </div>`,
          { flat: true },
        )}
      </div>
    `;
  }

  renderEnrollment(stepIndex) {
    const enrollmentOpen = this.state.phase?.enrollmentOpen === true;
    if (!enrollmentOpen) {
      return this.renderEnrollmentClosed();
    }

    const intro = STEP_INTROS.enroll;
    const editingExisting = Boolean(this.state.team?.id && this.state.team?.paymentStatus !== 'PAID');
    const submitLabel = editingExisting ? 'Guardar cambios e ir a pago' : 'Guardar equipo e ir a pago';

    return `
      <div class="apap-postulacion__panel apap-postulacion__wizard">
        <div class="apap-postulacion__toolbar">
          <div class="apap-postulacion__toolbar-head">
            <div>
              <h2 class="apap-postulacion__toolbar-title">${this.escape(intro.title)}</h2>
              <p class="apap-postulacion__item-meta">Paso ${stepIndex} de ${WIZARD_STEPS.length}${this.state.phase?.label ? ` · ${this.escape(this.state.phase.label)}` : ''}${editingExisting ? ' · Editando equipo' : ''}</p>
            </div>
            ${this.renderEnrollmentCountdown()}
          </div>
        </div>
        <nav class="apap-postulacion__wizard-nav" aria-label="Progreso de la inscripción">
          ${this.renderWizardSteps(stepIndex)}
        </nav>
        <div class="apap-postulacion__step-intro">
          <h3 class="apap-postulacion__section-title">${this.escape(intro.title)}</h3>
          <p class="apap-postulacion__section-lead">${this.escape(intro.lead)}</p>
        </div>
        <form class="apap-postulacion__form" data-form="enroll">
          <p class="apap-postulacion__required-note">Los campos marcados con <span class="apap-postulacion__required" aria-hidden="true">*</span> son obligatorios.</p>
          <div class="apap-postulacion__card-stack">
            ${this.renderCard(
              'Datos del equipo',
              this.renderTeamAgencyFields(),
              { hint: 'La tarifa se aplica automáticamente según si tu agencia es socia APAP.' },
            )}
            ${this.renderCard('Integrantes', this.renderMembersSection(), {
              hint: `Mínimo ${MIN_MEMBERS} y máximo ${MAX_MEMBERS} integrantes. Edad entre 18 y 28 años al 5 de agosto de 2026. Adjunta el DNI de cada integrante.`,
              required: true,
            })}
          </div>
          ${editingExisting ? '' : this.renderLegalAcceptance()}
          <div data-jt-error></div>
          <footer class="apap-postulacion__wizard-footer">
            <div class="apap-postulacion__wizard-footer-actions">
              ${
                editingExisting
                  ? '<button type="button" class="apap-postulacion__btn apap-postulacion__btn--ghost" data-action="back-pay">Volver al pago</button>'
                  : '<span aria-hidden="true"></span>'
              }
              <button type="submit" class="apap-postulacion__btn apap-postulacion__btn--primary">${submitLabel}</button>
            </div>
          </footer>
        </form>
      </div>
    `;
  }

  renderPay(stepIndex) {
    if (this.state.phase?.enrollmentOpen !== true) {
      return this.renderEnrollmentClosed();
    }

    const intro = STEP_INTROS.pay;
    const checkoutConfigured = this.state.checkoutConfigured !== false;
    const team = this.state.team;
    const members = Array.isArray(team?.members) ? team.members : [];
    const identityDocs = Array.isArray(team?.identityDocs) ? team.identityDocs : [];
    const needsIdentityUpload = identityDocs.length === 0;
    const memberList = members.length
      ? `<ul class="apap-postulacion__item-meta" style="margin: 0; padding-left: 1.1rem;">
          ${members
            .map(
              (member) =>
                `<li>${this.escape(`${member.firstName || ''} ${member.lastName || ''}`.trim() || member.email || 'Integrante')}</li>`,
            )
            .join('')}
        </ul>`
      : '<p class="apap-postulacion__item-meta">Sin integrantes cargados.</p>';
    const docsSummary = needsIdentityUpload
      ? `<div class="apap-postulacion__alert apap-postulacion__alert--warning">Faltan documentos de identidad. Súbelos aquí para continuar al pago.</div>
         <div class="apap-postulacion__field">
           ${this.renderFieldLabel('Documentos de identidad pendientes', { required: true })}
           <input class="apap-postulacion__input" type="file" name="identityDocs" accept="application/pdf,image/*" multiple required />
           <p class="apap-postulacion__field-hint">Adjunta un archivo por integrante (PDF o imagen).</p>
         </div>`
      : `<p class="apap-postulacion__item-meta">${identityDocs.length} documento${identityDocs.length === 1 ? '' : 's'} de identidad adjunto${identityDocs.length === 1 ? '' : 's'}.</p>`;

    return `
      <div class="apap-postulacion__panel apap-postulacion__wizard">
        <div class="apap-postulacion__toolbar">
          <div class="apap-postulacion__toolbar-head">
            <div>
              <h2 class="apap-postulacion__toolbar-title">${this.escape(intro.title)}</h2>
              <p class="apap-postulacion__item-meta">Paso ${stepIndex} de ${WIZARD_STEPS.length} · Equipo: ${this.escape(team?.pseudonym || '')}</p>
            </div>
          </div>
        </div>
        <nav class="apap-postulacion__wizard-nav" aria-label="Progreso de la inscripción">
          ${this.renderWizardSteps(stepIndex)}
        </nav>
        ${
          !checkoutConfigured
            ? `<div class="apap-postulacion__alert apap-postulacion__alert--warning">El pago aún no está configurado en Shopify (productos S/220 y S/275). Contacta al administrador.</div>`
            : ''
        }
        <div class="apap-postulacion__step-intro">
          <h3 class="apap-postulacion__section-title">${this.escape(intro.title)}</h3>
          <p class="apap-postulacion__section-lead">${this.escape(intro.lead)}</p>
        </div>
        <div class="apap-postulacion__card-stack">
          ${this.renderCard(
            'Resumen del equipo',
            `<p class="apap-postulacion__item-meta">Tarifa: ${this.escape(team?.declaredTierLabel || team?.declaredTier || '—')}</p>
             <p class="apap-postulacion__item-meta">Integrantes:</p>
             ${memberList}
             ${docsSummary}`,
          )}
        </div>
        <div data-jt-error></div>
        <footer class="apap-postulacion__wizard-footer">
          <div class="apap-postulacion__wizard-footer-actions">
            <button type="button" class="apap-postulacion__btn apap-postulacion__btn--ghost" data-action="back-enroll">Volver al registro</button>
            <button type="button" class="apap-postulacion__btn apap-postulacion__btn--primary" data-action="pay" ${checkoutConfigured ? '' : 'disabled'}>${needsIdentityUpload ? 'Subir documentos y pagar' : 'Ir a pagar'}</button>
          </div>
        </footer>
      </div>
    `;
  }

  formatBriefPublishDate(value) {
    if (!value) return 'el 5 de agosto de 2026';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return 'el 5 de agosto de 2026';
    const formatted = new Intl.DateTimeFormat('es-PE', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      timeZone: 'America/Lima',
    }).format(date);
    return `el ${formatted}`;
  }

  renderBrief(stepIndex) {
    const intro = STEP_INTROS.brief;
    const briefAvailable = this.state.phase?.proposalOpen === true;
    const publishDateLabel = this.formatBriefPublishDate(this.state.phase?.briefOpensAt);
    const basesUrl =
      this.basesUrl && this.basesUrl !== '#' ? this.basesUrl : BASES_DOWNLOAD_URL;
    const body = briefAvailable
      ? `<p class="apap-postulacion__section-lead" style="margin: 0;">Ya puedes descargar el brief.</p>
            <div class="apap-postulacion__wizard-footer-actions" style="margin-top: 1rem;">
              <a
                class="apap-postulacion__btn apap-postulacion__btn--primary"
                href="${this.escapeAttr(BRIEF_DOWNLOAD_URL)}"
                target="_blank"
                rel="noopener noreferrer"
              >Descargar brief</a>
            </div>
            <p class="apap-postulacion__section-lead" style="margin: 1.25rem 0 0;">Recuerda revisar las bases.</p>
            <div class="apap-postulacion__wizard-footer-actions" style="margin-top: 1rem;">
              <a
                class="apap-postulacion__btn apap-postulacion__btn--ghost"
                href="${this.escapeAttr(basesUrl)}"
                target="_blank"
                rel="noopener noreferrer"
              >Descargar bases</a>
            </div>`
      : `<p class="apap-postulacion__section-lead" style="margin: 0;">${this.escape(intro.lead)}</p>
            <p class="apap-postulacion__item-meta" style="margin: 0.5rem 0 0;">La publicación del brief se realizará ${this.escape(publishDateLabel)}. Estará disponible aquí a partir de esa fecha.</p>`;
    return `
      <div class="apap-postulacion__panel apap-postulacion__wizard">
        <div class="apap-postulacion__toolbar">
          <div class="apap-postulacion__toolbar-head">
            <div>
              <h2 class="apap-postulacion__toolbar-title">${this.escape(intro.title)}</h2>
              <p class="apap-postulacion__item-meta">Paso ${stepIndex} de ${WIZARD_STEPS.length} · Equipo: ${this.escape(this.state.team?.pseudonym || '')}</p>
            </div>
            ${this.renderBriefCountdown(briefAvailable)}
          </div>
        </div>
        <nav class="apap-postulacion__wizard-nav" aria-label="Progreso de la inscripción">
          ${this.renderWizardSteps(stepIndex)}
        </nav>
        <div class="apap-postulacion__card-stack">
          ${this.renderPaidRegistrationOverviewCard()}
          ${this.renderCard('', body, { flat: true })}
        </div>
        <div data-jt-error></div>
        <footer class="apap-postulacion__wizard-footer">
          <div class="apap-postulacion__wizard-footer-actions">
            ${this.renderRegistrationSummaryButton() || '<span aria-hidden="true"></span>'}
            <button type="button" class="apap-postulacion__btn apap-postulacion__btn--primary" data-action="continue-case" ${briefAvailable ? '' : 'disabled'}>
              Subir caso
            </button>
          </div>
        </footer>
      </div>
    `;
  }

  renderUploadTile(label, hint, accept, mediaType) {
    return `
      <label class="apap-postulacion__upload-tile" data-upload-tile="${this.escapeAttr(mediaType)}">
        <span class="apap-postulacion__upload-tile-label">${this.escape(label)}</span>
        <span class="apap-postulacion__upload-tile-hint">${this.escape(hint)}</span>
        <span class="apap-postulacion__upload-trigger">Seleccionar archivo</span>
        <div class="apap-postulacion__upload-status" hidden>
          <span class="apap-postulacion__upload-status-label">Subiendo…</span>
          <div class="apap-postulacion__upload-progress" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">
            <div class="apap-postulacion__upload-progress-bar"></div>
          </div>
        </div>
        <input type="file" class="apap-postulacion__upload-input" accept="${this.escapeAttr(accept)}" data-upload="${this.escapeAttr(mediaType)}">
      </label>
    `;
  }

  renderMediaList({ editable = true } = {}) {
    const media = this.state.team?.proposal?.mediaAssets ?? [];
    if (!media.length) {
      return '<p class="apap-postulacion__empty-state">Aún no hay medios adjuntos. Sube un archivo o agrega un enlace.</p>';
    }
    return `<div class="apap-postulacion__media-grid">${media.map((asset) => this.renderMediaCard(asset, { editable })).join('')}</div>`;
  }

  renderDocumentIcon() {
    return `<svg class="apap-postulacion__media-type-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"></path>
      <path d="M14 2v6h6" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"></path>
      <path d="M8 13h8M8 17h5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
    </svg>`;
  }

  renderWebsiteIcon() {
    return `<svg class="apap-postulacion__media-type-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.5"></circle>
      <path d="M3 12h18M12 3c2.5 2.8 4 6.1 4 9s-1.5 6.2-4 9M12 3c-2.5 2.8-4 6.1-4 9s1.5 6.2 4 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
    </svg>`;
  }

  renderExternalLinkPreview(asset, href) {
    return `<a class="apap-postulacion__media-file-link" href="${this.escapeAttr(href)}" target="_blank" rel="noopener noreferrer">
      ${this.renderWebsiteIcon()}
      <span class="apap-postulacion__media-file-label">${this.escape(asset.label ?? asset.externalUrl ?? 'Sitio web')}</span>
    </a>`;
  }

  renderMediaCard(asset, { editable = true } = {}) {
    const url = this.resolveMediaUrl(asset.downloadUrl);
    let previewInner = '';
    let previewClass = 'apap-postulacion__media-card-preview';
    if (asset.type === 'IMAGE') {
      previewInner = url
        ? `<img src="${this.escapeAttr(url)}" alt="${this.escapeAttr(asset.fileName ?? asset.label ?? 'Imagen')}" loading="lazy">`
        : '<p class="apap-postulacion__item-meta">Vista previa no disponible</p>';
    } else if (asset.type === 'VIDEO' && url) {
      previewInner = `<video controls preload="metadata" src="${this.escapeAttr(url)}"></video>`;
    } else if (asset.type === 'AUDIO' && url) {
      previewClass += ' apap-postulacion__media-card-preview--audio';
      previewInner = `<audio controls preload="metadata" src="${this.escapeAttr(url)}"></audio>`;
    } else if (asset.type === 'PDF' && url) {
      previewClass += ' apap-postulacion__media-card-preview--file';
      previewInner = `<a class="apap-postulacion__media-file-link" href="${this.escapeAttr(url)}" target="_blank" rel="noopener noreferrer">
        ${this.renderDocumentIcon()}
        <span class="apap-postulacion__media-file-label">${this.escape(asset.fileName ?? asset.label ?? 'PDF')}</span>
      </a>`;
    } else if (asset.type === 'VIDEO_URL' && asset.embedUrl) {
      previewInner = `<iframe src="${this.escapeAttr(asset.embedUrl)}" title="${this.escapeAttr(asset.label ?? 'Video')}" allowfullscreen loading="lazy"></iframe>`;
    } else if (asset.type === 'EXTERNAL_LINK') {
      previewClass += ' apap-postulacion__media-card-preview--file';
      previewInner = this.renderExternalLinkPreview(asset, asset.externalUrl ?? url ?? '#');
    } else if (asset.type === 'VIDEO_URL') {
      previewClass += ' apap-postulacion__media-card-preview--file';
      previewInner = this.renderExternalLinkPreview(asset, asset.externalUrl ?? url ?? '#');
    } else if (url) {
      previewInner = `<a href="${this.escapeAttr(url)}" target="_blank" rel="noopener noreferrer">${this.escape(asset.fileName ?? 'Descargar')}</a>`;
    } else {
      previewInner = `<p class="apap-postulacion__item-meta">${this.escape(asset.type)}</p>`;
    }
    const typeLabel =
      asset.type === 'VIDEO' || asset.type === 'VIDEO_URL' || asset.type === 'EXTERNAL_LINK'
        ? asset.type === 'VIDEO'
          ? 'Video'
          : asset.type === 'EXTERNAL_LINK'
            ? 'Sitio web'
            : 'Enlace'
        : asset.type === 'AUDIO'
          ? 'Audio'
          : asset.type;
    return `
      <article class="apap-postulacion__media-card">
        <div class="${previewClass}">${previewInner}</div>
        <div class="apap-postulacion__media-card-meta">
          <span class="apap-postulacion__media-type">${this.escape(typeLabel)}</span>
          <span class="apap-postulacion__media-name">${this.escape(asset.label ?? asset.fileName ?? asset.type)}</span>
        </div>
        ${
          editable
            ? `<button type="button" class="apap-postulacion__btn apap-postulacion__btn--sm apap-postulacion__btn--danger" data-delete-media="${this.escapeAttr(asset.id)}">Eliminar</button>`
            : ''
        }
      </article>
    `;
  }

  renderReviewRow(label, value, { multiline = false } = {}) {
    const content = multiline
      ? `<span class="apap-postulacion__review-multiline">${this.escape(value || '—').replace(/\n/g, '<br>')}</span>`
      : this.escape(value || '—');
    return `<div class="apap-postulacion__review-row"><dt>${this.escape(label)}</dt><dd>${content}</dd></div>`;
  }

  getProposalStatusBadgeClass(status) {
    switch (status) {
      case 'SUBMITTED':
      case 'UNDER_REVIEW':
        return 'apap-postulacion__badge--ingresada';
      case 'VERIFIED':
      case 'SHORTLIST':
      case 'WINNER':
        return 'apap-postulacion__badge--verificada';
      case 'OBSERVED':
        return 'apap-postulacion__badge--observada';
      case 'DRAFT':
      default:
        return 'apap-postulacion__badge--borrador';
    }
  }

  renderProposalFicha() {
    const team = this.state.team;
    const proposal = team?.proposal;
    if (!proposal) return '';

    const media = proposal.mediaAssets ?? [];
    const submittedAtLabel = proposal.submittedAt
      ? new Date(proposal.submittedAt).toLocaleDateString('es-PE', {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
        })
      : '';
    const statusMeta = [
      submittedAtLabel ? `Enviada el ${submittedAtLabel}` : '',
      this.state.edition?.year ? `Edición ${this.state.edition.year}` : '',
    ]
      .filter(Boolean)
      .join(' · ');
    const formatLabel =
      proposal.formatLabel || FORMATS.find((item) => item.value === proposal.format)?.label || '—';

    const sections = [
      this.renderCard(
        'Estado',
        `<dl class="apap-postulacion__review-dl">
          ${this.renderReviewRow('Estado', proposal.statusLabel ?? proposal.status)}
          ${statusMeta ? this.renderReviewRow('Detalle', statusMeta) : ''}
        </dl>`,
      ),
      this.renderCard(
        'Ficha de registro del caso',
        `<dl class="apap-postulacion__review-dl">
          ${this.renderReviewRow('Equipo', team.pseudonym)}
          ${this.renderReviewRow('Formato creativo', formatLabel)}
          ${this.renderReviewRow('Contexto', proposal.strategyContext, { multiline: true })}
          ${this.renderReviewRow('Insight', proposal.strategyInsight, { multiline: true })}
          ${this.renderReviewRow('Estrategia', proposal.strategyVision, { multiline: true })}
        </dl>`,
      ),
      this.renderCard(
        'Material creativo',
        `<dl class="apap-postulacion__review-dl">
          ${this.renderReviewRow('Piezas adjuntas', String(media.length))}
        </dl>
        ${
          media.length
            ? this.renderMediaList({ editable: false })
            : '<p class="apap-postulacion__item-meta">Sin medios adjuntos.</p>'
        }`,
        { flat: true },
      ),
    ];

    return `<div class="apap-postulacion__review">${sections.join('')}</div>`;
  }

  renderProposalView() {
    const team = this.state.team;
    const proposal = team?.proposal;
    if (!team || !proposal) return this.renderDoneFallback();

    return `
      <div class="apap-postulacion__panel">
        <div class="apap-postulacion__toolbar">
          <div>
            <h2 class="apap-postulacion__toolbar-title">${this.escape(team.pseudonym || 'Tu equipo')}</h2>
            <p class="apap-postulacion__item-meta">Ficha completa de la propuesta</p>
          </div>
          ${this.renderRegistrationSummaryButton({ ghost: false })}
        </div>
        <p><span class="apap-postulacion__badge ${this.getProposalStatusBadgeClass(proposal.status)}">${this.escape(proposal.statusLabel ?? proposal.status)}</span></p>
        ${
          proposal.verificationNote
            ? `<div class="apap-postulacion__alert apap-postulacion__alert--warning"><strong>Observación:</strong> ${this.escape(proposal.verificationNote)}</div>`
            : ''
        }
        ${this.renderProposalFicha()}
      </div>
    `;
  }

  renderCase(stepIndex) {
    const intro = STEP_INTROS.case;
    const proposal = this.state.team?.proposal || {};
    const proposalOpen = this.state.phase?.proposalOpen === true;
    const canEdit = proposalOpen || proposal.status === 'OBSERVED';
    const fieldAttrs = canEdit ? '' : 'disabled';
    const mediaCount = proposal.mediaAssets?.length ?? 0;
    const canAddMedia = canEdit && mediaCount < MAX_CREATIVE_PIECES;
    const saveLabel = proposal.status === 'OBSERVED' ? 'Guardar cambios' : 'Guardar borrador';
    const submitLabel = proposal.status === 'OBSERVED' ? 'Reenviar propuesta' : 'Enviar propuesta';
    return `
      <div class="apap-postulacion__panel apap-postulacion__wizard">
        <div class="apap-postulacion__toolbar">
          <div class="apap-postulacion__toolbar-head">
            <div>
              <h2 class="apap-postulacion__toolbar-title">${this.escape(intro.title)}</h2>
              <p class="apap-postulacion__item-meta">Paso ${stepIndex} de ${WIZARD_STEPS.length} · Equipo: ${this.escape(this.state.team?.pseudonym || '')}</p>
            </div>
          </div>
        </div>
        <nav class="apap-postulacion__wizard-nav" aria-label="Progreso de la inscripción">
          ${this.renderWizardSteps(stepIndex)}
        </nav>
        <div class="apap-postulacion__step-intro">
          <h3 class="apap-postulacion__section-title">${this.escape(intro.title)}</h3>
          <p class="apap-postulacion__section-lead">${this.escape(intro.lead)}</p>
        </div>
        ${
          proposalOpen || this.isProposalWindowUpcoming()
            ? this.renderEditionCountdown()
            : ''
        }
        ${this.renderProposalWindowAlert(proposal)}
        ${
          proposal.status === 'OBSERVED' && proposal.verificationNote
            ? `<div class="apap-postulacion__alert apap-postulacion__alert--warning"><strong>Observación:</strong> ${this.escape(proposal.verificationNote)}</div>`
            : ''
        }
        <form class="apap-postulacion__form" data-form="case">
          <div class="apap-postulacion__card-stack">
            ${this.renderCard(
              'Ficha de registro del caso',
              `<div class="apap-postulacion__field-grid">
                ${this.renderSelectField('format', 'Formato creativo', proposal.format || 'GRAFICA', FORMATS, { required: true, attrs: fieldAttrs })}
                ${this.renderTextarea('strategyContext', 'Contexto', proposal.strategyContext || '', { required: true, attrs: fieldAttrs })}
                ${this.renderTextarea('strategyInsight', 'Insight', proposal.strategyInsight || '', { required: true, attrs: fieldAttrs })}
                ${this.renderTextarea('strategyVision', 'Estrategia', proposal.strategyVision || '', { required: true, attrs: fieldAttrs })}
              </div>`,
              { hint: 'Responde al brief con tu planteamiento estratégico.' },
            )}
            ${this.renderCard(
              'Material creativo',
              `<p class="apap-postulacion__item-meta">${mediaCount} / ${MAX_CREATIVE_PIECES} piezas</p>
              <div data-media-list>${this.renderMediaList({ editable: canEdit })}</div>
              ${
                canAddMedia
                  ? `<div class="apap-postulacion__upload-grid">
                      ${this.renderUploadTile('Imagen', 'JPG, PNG, WEBP · máx. 20 MB · 5000×5000 px', 'image/jpeg,image/png,image/webp,image/gif', 'IMAGE')}
                      ${
                        ENABLE_VIDEO_FILE_UPLOAD
                          ? this.renderUploadTile(
                              'Video',
                              'MP4/MOV H.264 · máx. 400 MB',
                              'video/mp4,video/quicktime,.mp4,.mov',
                              'VIDEO',
                            )
                          : ''
                      }
                      ${this.renderUploadTile('Audio', 'MP3, WAV · máx. 50 MB', 'audio/mpeg,audio/wav,audio/mp3', 'AUDIO')}
                      ${this.renderUploadTile('PDF', 'Documento · máx. 20 MB', 'application/pdf', 'PDF')}
                    </div>`
                  : canEdit
                    ? `<p class="apap-postulacion__item-meta">Alcanzaste el máximo de ${MAX_CREATIVE_PIECES} piezas creativas.</p>`
                    : ''
              }`,
              { hint: 'Adjunta al menos un archivo o enlace.', required: true },
            )}
            ${
              canAddMedia
                ? this.renderCard(
                    'Enlaces externos',
                    `<div class="apap-postulacion__field-grid apap-postulacion__field-grid--2">
                      ${this.renderTextField('linkLabel', 'Etiqueta', 'Enlace externo')}
                      ${this.renderTextField('externalUrl', 'URL', '', { placeholder: 'https://...' })}
                    </div>
                    <p class="apap-postulacion__item-meta">YouTube, Vimeo, Google Drive u otro enlace público.</p>
                    <button type="button" class="apap-postulacion__btn apap-postulacion__btn--sm" data-action="add-external-link">Agregar enlace</button>`,
                  )
                : ''
            }
          </div>
          ${canEdit ? this.renderCaseLegalAcceptance() : ''}
          <div data-jt-error></div>
          <footer class="apap-postulacion__wizard-footer">
            <div class="apap-postulacion__wizard-footer-actions">
              <div style="display: flex; flex-wrap: wrap; gap: 0.5rem;">
                <button type="button" class="apap-postulacion__btn apap-postulacion__btn--ghost" data-action="back-brief">Volver al brief</button>
                ${this.renderRegistrationSummaryButton()}
              </div>
              ${
                canEdit
                  ? `<div style="display: flex; flex-wrap: wrap; gap: 0.5rem;">
                <button type="button" class="apap-postulacion__btn apap-postulacion__btn--ghost" data-action="save-draft">${this.escape(saveLabel)}</button>
                <button type="button" class="apap-postulacion__btn apap-postulacion__btn--primary" data-action="submit-proposal">${this.escape(submitLabel)}</button>
              </div>`
                  : ''
              }
            </div>
          </footer>
        </form>
      </div>
    `;
  }

  renderDoneFallback() {
    return `
      <div class="apap-postulacion__panel">
        ${this.renderCard(
          'Propuesta enviada',
          `<div class="apap-postulacion__alert apap-postulacion__alert--success">
            Equipo <strong>${this.escape(this.state.team?.pseudonym || '')}</strong>: ${this.escape(this.state.team?.proposal?.statusLabel || 'Enviada')}
          </div>
          <p class="apap-postulacion__section-lead">Recibirás novedades según el calendario del concurso.</p>`,
        )}
      </div>
    `;
  }

  render() {
    if (this.state.loading) {
      this.setHostHtml(this.renderLoading());
      this.ensurePhasePreviewDock();
      return;
    }

    if (this.state.view === 'login') {
      this.setHostHtml(this.renderLogin());
      this.ensurePhasePreviewDock();
      return;
    }

    if (this.state.view === 'profile') {
      this.setHostHtml(this.renderProfile());
      const profileForm = this.querySelector('[data-form="profile"]');
      if (profileForm instanceof HTMLFormElement) this.syncProfilePartnerFields(profileForm);
      this.bindEvents();
      this.ensurePhasePreviewDock();
      return;
    }

    if (this.state.view === 'registration-summary') {
      this.setHostHtml(this.renderRegistrationSummary());
      this.bindEvents();
      this.ensurePhasePreviewDock();
      return;
    }

    if (this.state.view === 'error') {
      this.setHostHtml(`
        <div class="apap-postulacion__panel">
          ${this.renderCard(
            'No se pudo cargar',
            `<div class="apap-postulacion__alert apap-postulacion__alert--error">${this.escape(this.state.errorMessage || 'Error desconocido')}</div>
            <button type="button" class="apap-postulacion__btn apap-postulacion__btn--primary" data-action="retry">Reintentar</button>`,
          )}
        </div>
      `);
      this.querySelector('[data-action="retry"]')?.addEventListener('click', () => {
        this.state = { ...this.state, loading: true, view: 'app', errorMessage: null };
        void this.bootstrap();
      });
      this.ensurePhasePreviewDock();
      return;
    }

    if (!this.state.authenticated) {
      this.setHostHtml(this.renderLogin());
      this.ensurePhasePreviewDock();
      return;
    }

    if (this.state.step === 'done') {
      this.setHostHtml(this.renderProposalView());
      this.bindEvents();
      this.ensurePhasePreviewDock();
      return;
    }

    const stepIndex = stepKeyToIndex(this.state.step);
    if (this.state.step === 'enroll') {
      this.setHostHtml(this.renderEnrollment(stepIndex));
      const enrollForm = this.querySelector('[data-form="enroll"]');
      if (enrollForm instanceof HTMLFormElement) this.syncEnrollPartnerFields(enrollForm);
    } else if (this.state.step === 'pay') {
      this.setHostHtml(this.renderPay(stepIndex));
    } else if (this.state.step === 'brief') {
      this.setHostHtml(this.renderBrief(stepIndex));
    } else {
      this.setHostHtml(this.renderCase(stepIndex));
    }
    this.bindEvents();
    this.startCountdownTimer();
    this.ensurePhasePreviewDock();
  }

  showError(message) {
    const errorEl = this.querySelector('[data-jt-error]');
    if (!errorEl) return;
    errorEl.innerHTML = message
      ? `<div class="apap-postulacion__alert apap-postulacion__alert--error">${this.escape(message)}</div>`
      : '';
  }

  setButtonLoading(button, loading, loadingLabel = 'Cargando…') {
    if (!(button instanceof HTMLButtonElement)) return;
    if (loading) {
      if (!button.dataset.loadingActive) {
        button.dataset.originalLabel = button.textContent?.trim() ?? '';
        button.dataset.loadingActive = 'true';
      }
      button.disabled = true;
      button.classList.add('apap-postulacion__btn--loading');
      button.setAttribute('aria-busy', 'true');
      button.replaceChildren();
      const spinner = document.createElement('span');
      spinner.className = 'apap-postulacion__btn-spinner';
      spinner.setAttribute('aria-hidden', 'true');
      const label = document.createElement('span');
      label.textContent = loadingLabel;
      button.append(spinner, label);
      return;
    }
    button.disabled = false;
    button.classList.remove('apap-postulacion__btn--loading');
    button.removeAttribute('aria-busy');
    if (button.dataset.loadingActive) {
      button.textContent = button.dataset.originalLabel ?? '';
      delete button.dataset.loadingActive;
      delete button.dataset.originalLabel;
    }
  }

  readMembersFromForm(form) {
    const previous = this.state.members?.length ? this.state.members : [emptyMember(), emptyMember()];
    return previous.map((prev, index) => {
      const input = form.querySelector(`[name="member_${index}_identityDoc"]`);
      const nextFile = input instanceof HTMLInputElement && input.files?.[0] ? input.files[0] : null;
      const identityFile = nextFile || prev.identityFile || null;
      return {
        firstName: form.querySelector(`[name="member_${index}_firstName"]`)?.value?.trim() || '',
        lastName: form.querySelector(`[name="member_${index}_lastName"]`)?.value?.trim() || '',
        email: form.querySelector(`[name="member_${index}_email"]`)?.value?.trim() || '',
        phone: form.querySelector(`[name="member_${index}_phone"]`)?.value?.trim() || '',
        birthDate: form.querySelector(`[name="member_${index}_birthDate"]`)?.value?.trim() || '',
        memberType: form.querySelector(`[name="member_${index}_memberType"]`)?.value || 'AGENCY_PRO',
        agencyName: form.querySelector(`[name="member_${index}_agencyName"]`)?.value?.trim() || '',
        identityFile,
        identityFileName: identityFile?.name || prev.identityFileName || '',
        identityUploaded: Boolean(prev.identityUploaded) && !identityFile,
      };
    });
  }

  assertMembersHaveIdentityDocs(members) {
    const missing = members.findIndex(
      (member) => !(member.identityFile instanceof File) && !member.identityUploaded,
    );
    if (missing >= 0) {
      throw new Error(`Adjunta el documento de identidad del integrante ${missing + 1}.`);
    }
  }

  membersPayloadForApi(members) {
    return members.map((member) => ({
      firstName: member.firstName,
      lastName: member.lastName,
      email: member.email,
      phone: member.phone,
      birthDate: member.birthDate,
      memberType: member.memberType,
      agencyName: member.agencyName,
    }));
  }

  async uploadMemberIdentityDocs(teamId, members) {
    for (let index = 0; index < members.length; index += 1) {
      const member = members[index];
      const file = member.identityFile;
      if (!(file instanceof File)) continue;
      const label = `DNI — Integrante ${index + 1} — ${[member.firstName, member.lastName].filter(Boolean).join(' ').trim() || member.email || 'Sin nombre'}`;
      await this.uploadFile(
        {
          youthTeamId: teamId,
          uploadKind: 'identity',
          fileName: file.name,
          mimeType: file.type || 'application/pdf',
          fileSize: file.size,
          mediaType: file.type.startsWith('image/') ? 'IMAGE' : 'PDF',
          label,
        },
        file,
      );
    }
  }

  hydrateEnrollmentFromTeam(team) {
    if (!team) return {};
    const isPartner = team.declaredTier === 'APAP_PARTNER';
    const agencies = Array.isArray(this.state.partnerAgencies) ? this.state.partnerAgencies : [];
    const matchedAgency = agencies.find(
      (agency) => agency.name === team.agencyName || agency.id === team.agencyName,
    );
    const identityDocs = Array.isArray(team.identityDocs) ? team.identityDocs : [];
    const members = (Array.isArray(team.members) ? team.members : []).map((member, index) => ({
      firstName: member.firstName || '',
      lastName: member.lastName || '',
      email: member.email || '',
      phone: member.phone || '',
      birthDate: member.birthDate?.slice?.(0, 10) || member.birthDate || '',
      memberType: member.memberType || 'AGENCY_PRO',
      agencyName: member.agencyName || '',
      identityFile: null,
      identityFileName: '',
      identityUploaded: index < identityDocs.length,
    }));

    return {
      isApapPartner: isPartner,
      enrollPseudonym: team.pseudonym || '',
      enrollAgencyName: isPartner ? '' : team.agencyName || '',
      enrollPartnerAgencyId: isPartner ? matchedAgency?.id || '' : '',
      members: members.length >= MIN_MEMBERS ? members : [emptyMember(), emptyMember()],
    };
  }

  goBackToEnrollment() {
    const draft = this.hydrateEnrollmentFromTeam(this.state.team);
    this.setState({
      ...draft,
      step: 'enroll',
    });
  }

  readEnrollmentDraftFromForm(form) {
    if (!(form instanceof HTMLFormElement)) return null;
    const isPartner = Boolean(form.querySelector('input[name="isApapPartner"][value="true"]')?.checked);
    return {
      isApapPartner: isPartner,
      enrollPseudonym: form.querySelector('[name="pseudonym"]')?.value || '',
      enrollAgencyName: form.querySelector('[name="agencyName"]')?.value || '',
      enrollPartnerAgencyId: form.querySelector('[name="partnerAgencyId"]')?.value || '',
      members: this.readMembersFromForm(form),
    };
  }

  addEnrollmentMember() {
    const form = this.querySelector('[data-form="enroll"]');
    const draft = this.readEnrollmentDraftFromForm(form);
    const members = draft?.members?.length ? [...draft.members] : [...(this.state.members || [])];
    if (members.length >= MAX_MEMBERS) return;
    members.push(emptyMember());
    this.setState({
      ...(draft || {}),
      members,
    });
  }

  removeEnrollmentMember(index) {
    const form = this.querySelector('[data-form="enroll"]');
    const draft = this.readEnrollmentDraftFromForm(form);
    const members = draft?.members?.length ? [...draft.members] : [...(this.state.members || [])];
    if (members.length <= MIN_MEMBERS) return;
    const nextIndex = Number(index);
    if (!Number.isInteger(nextIndex) || nextIndex < 0 || nextIndex >= members.length) return;
    members.splice(nextIndex, 1);
    this.setState({
      ...(draft || {}),
      members,
    });
  }

  bindEvents() {
    if (this.host.dataset.jtBound === 'true') return;
    this.host.dataset.jtBound = 'true';
    const root = this.host;

    root.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) return;
      if (target.matches('[data-jt-partner-toggle]')) {
        const form = target.closest('[data-form="enroll"]');
        if (form instanceof HTMLFormElement) this.syncEnrollPartnerFields(form);
        return;
      }
      if (target.matches('[data-profile-partner-toggle]')) {
        const form = target.closest('[data-form="profile"]');
        if (form instanceof HTMLFormElement) this.syncProfilePartnerFields(form);
      }
    });

    root.addEventListener('submit', async (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !root.contains(form)) return;

      if (form.matches('[data-form="profile"]')) {
        event.preventDefault();
        await this.handleProfileSubmit(form);
        return;
      }

      if (!form.matches('[data-form="enroll"]')) return;
      event.preventDefault();
      this.showError('');
      const button = form.querySelector('[type="submit"]');
      const editingExisting = Boolean(this.state.team?.id && this.state.team?.paymentStatus !== 'PAID');
      this.setButtonLoading(
        button,
        true,
        editingExisting ? 'Guardando…' : 'Guardando equipo…',
      );
      try {
        const agencyPayload = this.resolveEnrollAgencyPayload(form);
        const members = this.readMembersFromForm(form);
        this.assertMembersHaveIdentityDocs(members);
        const payload = {
          pseudonym: form.querySelector('[name="pseudonym"]')?.value?.trim(),
          declaredTier: agencyPayload.declaredTier,
          agencyName: agencyPayload.agencyName,
          legalAccepted: editingExisting
            ? true
            : Boolean(form.querySelector('[name="legalAccepted"]')?.checked),
          members: this.membersPayloadForApi(members),
        };
        const result = editingExisting
          ? await this.apiFetch(`/jovenes-talento/team/${this.state.team.id}`, {
              method: 'POST',
              body: JSON.stringify(payload),
            })
          : await this.apiFetch('/jovenes-talento/team', {
              method: 'POST',
              body: JSON.stringify(payload),
            });
        const teamId = result.team?.id;
        if (!teamId) {
          throw new Error(editingExisting ? 'No se pudo actualizar el equipo.' : 'No se pudo crear el equipo.');
        }
        this.setButtonLoading(button, true, 'Subiendo documentos…');
        try {
          await this.uploadMemberIdentityDocs(teamId, members);
        } catch (uploadError) {
          const dashboard = await this.refreshTeam().catch(() => null);
          this.setState({
            team: dashboard?.team || result.team,
            step: 'pay',
          });
          throw new Error(
            uploadError instanceof Error
              ? `Equipo guardado, pero no se pudieron subir todos los DNI: ${uploadError.message}`
              : 'Equipo guardado, pero no se pudieron subir todos los DNI.',
          );
        }
        this.setButtonLoading(button, true, 'Cargando pago…');
        const dashboard = await this.refreshTeam();
        this.setState({
          team: dashboard.team || result.team,
          step: 'pay',
          members: members.map((member) => ({
            ...member,
            identityFile: null,
            identityFileName: member.identityFileName || '',
            identityUploaded: true,
          })),
        });
      } catch (error) {
        this.showError(error.message);
        this.setButtonLoading(button, false);
      }
    });

    root.addEventListener('click', async (event) => {
      const target = event.target instanceof Element ? event.target.closest('[data-action], [data-delete-media]') : null;
      if (!target || !root.contains(target)) return;
      if (!(target instanceof HTMLButtonElement)) return;

      if (target.hasAttribute('data-delete-media')) {
        void this.deleteMedia(target.getAttribute('data-delete-media'));
        return;
      }

      const action = target.getAttribute('data-action');
      if (action === 'add-member') {
        this.addEnrollmentMember();
        return;
      }
      if (action === 'remove-member') {
        this.removeEnrollmentMember(target.getAttribute('data-member-index'));
        return;
      }
      if (action === 'back-enroll') {
        this.goBackToEnrollment();
        return;
      }
      if (action === 'back-pay') {
        this.setState({ step: 'pay' });
        return;
      }
      if (action === 'view-registration') {
        this.openRegistrationSummary();
        return;
      }
      if (action === 'back-registration') {
        this.closeRegistrationSummary();
        return;
      }
      if (action === 'continue-case') {
        sessionStorage.setItem(`apap-jt-brief-${this.state.team.id}`, '1');
        this.setState({ step: 'case' });
        return;
      }
      if (action === 'back-brief') {
        this.setState({ step: 'brief' });
        return;
      }
      if (action === 'pay') {
        this.showError('');
        target.disabled = true;
        try {
          if (!this.state.team?.identityDocs?.length) {
            const input = this.querySelector('[name="identityDocs"]');
            const files = input instanceof HTMLInputElement ? Array.from(input.files || []) : [];
            if (!files.length) {
              throw new Error('Adjunta el documento de identidad de cada integrante para continuar.');
            }
            for (const [index, file] of files.entries()) {
              await this.uploadFile(
                {
                  youthTeamId: this.state.team.id,
                  uploadKind: 'identity',
                  fileName: file.name,
                  mimeType: file.type || 'application/pdf',
                  fileSize: file.size,
                  mediaType: file.type.startsWith('image/') ? 'IMAGE' : 'PDF',
                  label: `DNI — Archivo ${index + 1}`,
                },
                file,
              );
            }
            await this.refreshTeam();
          }
          const result = await this.apiFetch('/jovenes-talento/checkout', {
            method: 'POST',
            body: JSON.stringify({ teamId: this.state.team.id }),
          });
          window.location.href = result.checkoutUrl;
        } catch (error) {
          this.showError(error.message);
          target.disabled = false;
        }
        return;
      }
      if (action === 'save-draft') {
        this.showError('');
        const form = this.querySelector('[data-form="case"]');
        try {
          const result = await this.apiFetch(`/jovenes-talento/team/${this.state.team.id}/proposal`, {
            method: 'PUT',
            body: JSON.stringify(this.readProposalPayload(form)),
          });
          this.setState({ team: result.team });
        } catch (error) {
          this.showError(error.message);
        }
        return;
      }
      if (action === 'add-external-link') {
        this.showError('');
        target.disabled = true;
        const form = this.querySelector('[data-form="case"]');
        try {
          const result = await this.apiFetch(`/jovenes-talento/team/${this.state.team.id}/proposal`, {
            method: 'PUT',
            body: JSON.stringify({
              intent: 'add_external_link',
              externalUrl: form.querySelector('[name="externalUrl"]')?.value?.trim(),
              linkLabel: form.querySelector('[name="linkLabel"]')?.value?.trim() || 'Enlace externo',
            }),
          });
          this.setState({ team: result.team });
        } catch (error) {
          this.showError(error.message);
        } finally {
          target.disabled = false;
        }
        return;
      }
      if (action === 'submit-proposal') {
        this.showError('');
        target.disabled = true;
        const form = this.querySelector('[data-form="case"]');
        const acceptTerms = form?.querySelector(`[name="${ACCEPT_TERMS_FIELD}"]`)?.checked;
        const acceptPrivacy = form?.querySelector(`[name="${ACCEPT_PRIVACY_FIELD}"]`)?.checked;
        if (!acceptTerms || !acceptPrivacy) {
          this.showError(LEGAL_ACCEPTANCE_ERROR_MESSAGE);
          target.disabled = false;
          return;
        }
        try {
          await this.apiFetch(`/jovenes-talento/team/${this.state.team.id}/proposal`, {
            method: 'PUT',
            body: JSON.stringify({ ...this.readProposalPayload(form), anonymityAccepted: true }),
          });
          const result = await this.apiFetch(`/jovenes-talento/team/${this.state.team.id}/submit`, {
            method: 'POST',
            body: JSON.stringify({
              [ACCEPT_TERMS_FIELD]: true,
              [ACCEPT_PRIVACY_FIELD]: true,
            }),
          });
          this.setState({ team: result.team, step: 'done' });
        } catch (error) {
          this.showError(error.message);
          target.disabled = false;
        }
      }
    });

    root.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) return;
      if (!root.contains(target)) return;
      if (target.matches('[data-upload]')) {
        void this.handleMediaUpload(target);
      }
    });
  }

  updateMediaList() {
    const list = this.querySelector('[data-media-list]');
    if (list) list.innerHTML = this.renderMediaList();
  }

  readImageDimensions(file) {
    return new Promise((resolve, reject) => {
      const url = URL.createObjectURL(file);
      const img = new Image();
      img.onload = () => {
        URL.revokeObjectURL(url);
        resolve({ width: img.naturalWidth, height: img.naturalHeight });
      };
      img.onerror = () => {
        URL.revokeObjectURL(url);
        reject(new Error('No se pudo leer la imagen.'));
      };
      img.src = url;
    });
  }

  async validateMediaFile(file, mediaType) {
    const limits = MEDIA_UPLOAD_LIMITS[mediaType];
    if (!limits) return { ok: true };
    if (file.size > limits.maxBytes) {
      return { ok: false, message: `El archivo debe pesar menos de ${limits.label}.` };
    }
    if (limits.accept?.length && file.type) {
      const mimeOk =
        limits.accept.includes(file.type) ||
        (mediaType === 'AUDIO' && file.type.startsWith('audio/'));
      if (!mimeOk) {
        return {
          ok: false,
          message:
            mediaType === 'VIDEO'
              ? 'Solo se permiten videos MP4 o MOV en H.264.'
              : 'Tipo de archivo no permitido para esta zona.',
        };
      }
    }
    if (mediaType === 'IMAGE' && limits.maxPixels) {
      try {
        const { width, height } = await this.readImageDimensions(file);
        if (width > limits.maxPixels || height > limits.maxPixels) {
          return {
            ok: false,
            message: `La imagen no puede superar ${limits.maxPixels}×${limits.maxPixels} píxeles.`,
          };
        }
      } catch {
        return { ok: false, message: 'No se pudo leer la imagen.' };
      }
    }
    if (mediaType === 'VIDEO') {
      try {
        await assertShopifyCompatibleVideoFile(file);
      } catch (error) {
        return {
          ok: false,
          message: error instanceof Error ? error.message : 'El formato del video no está permitido.',
        };
      }
    }
    return { ok: true };
  }

  setUploadTileProgress(tile, { uploading, progress = 0, fileName = '' } = {}) {
    if (!tile) return;
    tile.classList.toggle('apap-postulacion__upload-tile--uploading', !!uploading);
    const status = tile.querySelector('.apap-postulacion__upload-status');
    const bar = tile.querySelector('.apap-postulacion__upload-progress-bar');
    const label = tile.querySelector('.apap-postulacion__upload-status-label');
    const progressbar = tile.querySelector('.apap-postulacion__upload-progress');
    if (status) status.hidden = !uploading;
    const pct = Math.max(0, Math.min(100, progress));
    if (bar) bar.style.width = `${pct}%`;
    if (progressbar) progressbar.setAttribute('aria-valuenow', String(Math.round(pct)));
    if (label) {
      label.textContent =
        pct >= 100
          ? 'Finalizando…'
          : fileName
            ? `Subiendo ${fileName}… ${Math.round(pct)}%`
            : `Subiendo… ${Math.round(pct)}%`;
    }
  }

  resetUploadTile(tile, input) {
    if (tile) {
      this.setUploadTileProgress(tile, { uploading: false, progress: 0 });
    }
    if (input) {
      input.disabled = false;
      input.value = '';
    }
  }

  async handleMediaUpload(input) {
    const file = input.files?.[0];
    if (!file) return;
    const mediaType = input.getAttribute('data-upload');
    const tile = input.closest('.apap-postulacion__upload-tile');
    if (tile?.classList.contains('apap-postulacion__upload-tile--uploading')) return;

    const mediaCount = this.state.team?.proposal?.mediaAssets?.length ?? 0;
    if (mediaCount >= MAX_CREATIVE_PIECES) {
      this.showError(`Solo puedes subir hasta ${MAX_CREATIVE_PIECES} piezas creativas.`);
      return;
    }

    const validation = await this.validateMediaFile(file, mediaType);
    if (!validation.ok) {
      this.showError(validation.message);
      return;
    }

    input.disabled = true;
    this.setUploadTileProgress(tile, { uploading: true, progress: 0, fileName: file.name });
    this.showError('');

    try {
      await this.uploadFile(
        {
          youthProposalId: this.state.team.proposal.id,
          fileName: file.name,
          mimeType: file.type || 'application/octet-stream',
          fileSize: file.size,
          mediaType,
        },
        file,
        (progress) => this.setUploadTileProgress(tile, { uploading: true, progress, fileName: file.name }),
      );
      await this.refreshTeam();
      this.updateMediaList();
      const uploadSection = this.querySelector('[data-media-list]')?.closest('.apap-postulacion__card');
      if (uploadSection) {
        const mediaCount = this.state.team?.proposal?.mediaAssets?.length ?? 0;
        const counter = uploadSection.querySelector('.apap-postulacion__item-meta');
        if (counter) counter.textContent = `${mediaCount} / ${MAX_CREATIVE_PIECES} piezas`;
      }
    } catch (error) {
      this.showError(error.message);
      this.resetUploadTile(tile, input);
    }
  }

  async deleteMedia(assetId) {
    if (!assetId) return;
    this.showError('');
    try {
      const result = await this.apiFetch(`/jovenes-talento/team/${this.state.team.id}/proposal`, {
        method: 'PUT',
        body: JSON.stringify({ intent: 'delete_media', assetId }),
      });
      this.setState({ team: result.team });
    } catch (error) {
      this.showError(error.message);
    }
  }

  readProposalPayload(form) {
    return {
      format: form.querySelector('[name="format"]')?.value,
      strategyContext: form.querySelector('[name="strategyContext"]')?.value,
      strategyInsight: form.querySelector('[name="strategyInsight"]')?.value,
      strategyVision: form.querySelector('[name="strategyVision"]')?.value,
    };
  }

  collectStorefrontCustomerHint() {
    const dataset = this.host?.dataset ?? {};
    const body = {
      email: String(dataset.customerEmail ?? '').trim(),
      firstName: String(dataset.customerFirstName ?? '').trim(),
      lastName: String(dataset.customerLastName ?? '').trim(),
      phone: String(dataset.customerPhone ?? '').trim(),
    };
    if (!body.firstName && !body.lastName) {
      const fullName = String(dataset.customerName ?? '').trim();
      if (fullName) {
        const parts = fullName.split(/\s+/);
        body.firstName = parts[0] || '';
        body.lastName = parts.slice(1).join(' ');
      }
    }
    return body;
  }

  async bootstrap() {
    this.render();
    try {
      let me = await this.apiFetch('/session/me');
      if (!me.authenticated) {
        try {
          await this.apiFetch('/session/bootstrap', {
            method: 'POST',
            body: JSON.stringify(this.collectStorefrontCustomerHint()),
          });
          me = await this.apiFetch('/session/me');
        } catch (error) {
          if (error.code === 'NOT_LOGGED_IN') {
            this.setState({ loading: false, view: 'login', authenticated: false });
            return;
          }
          throw error;
        }
      }

      if (!me.authenticated) {
        this.setState({ loading: false, view: 'login', authenticated: false });
        return;
      }

      // Jurados/admin: salir de la inscripción JT y ir al portal staff.
      // Quienes pueden impersonar se quedan en el storefront.
      if (me.staffRedirect && !me.canImpersonate) {
        window.location.assign(me.staffRedirect);
        return;
      }

      if (!me.profileComplete) {
        await this.showProfileOnboarding(me.participant);
        return;
      }

      await this.enterYouthApp(me.participant);
    } catch (error) {
      if (error.code === 'NOT_LOGGED_IN' || error.code === 'UNAUTHORIZED') {
        this.setState({ loading: false, view: 'login', authenticated: false, step: 'enroll', team: null, brief: null });
        return;
      }
      if (error.code === 'PROFILE_INCOMPLETE') {
        try {
          const me = await this.apiFetch('/session/me');
          await this.showProfileOnboarding(me.participant || this.state.participant);
        } catch {
          await this.showProfileOnboarding(this.state.participant);
        }
        return;
      }
      this.setState({
        loading: false,
        view: 'error',
        authenticated: false,
        errorMessage: error.message || 'No se pudo cargar la inscripción.',
      });
    }
  }
}

function ensurePostulacionStyles() {
  if (document.querySelector('link[href*="apap-postulacion.css"]')) return;

  const script = document.querySelector('script[src*="apap-jovenes-talento.js"]');
  if (!script?.src) return;

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = script.src.replace(/apap-jovenes-talento\.js(\?.*)?$/, 'apap-postulacion.css');
  document.head.appendChild(link);
}

function mountApapJtHost(host) {
  if (host.dataset.apapJtMounted === 'true') return;
  ensurePostulacionStyles();
  host.dataset.apapJtMounted = 'true';
  host.classList.add('apap-postulacion');
  if (!host.querySelector('.apap-postulacion__loading') && !host.children.length) {
    host.innerHTML = `
      <div class="apap-postulacion__loading" aria-live="polite">
        <p class="apap-postulacion__loading-text">Cargando inscripción…</p>
      </div>
    `;
  }
  new ApapJtApp(host).start();
}

class ApapJovenesTalento extends HTMLElement {
  connectedCallback() {
    mountApapJtHost(this);
  }
}

if (!customElements.get('apap-jovenes-talento')) {
  customElements.define('apap-jovenes-talento', ApapJovenesTalento);
}

function bootLegacyApapJtRoots() {
  document.querySelectorAll('[data-apap-jt-root]').forEach((host) => {
    if (host.tagName.toLowerCase() === 'apap-jovenes-talento') return;
    mountApapJtHost(host);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    ensurePostulacionStyles();
    bootLegacyApapJtRoots();
  });
} else {
  ensurePostulacionStyles();
  bootLegacyApapJtRoots();
}
